//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.4.0.0 (NJsonSchema v11.3.2.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

import { CommonServices } from "@/services/CommonServices";
import * as OM from "@/model";
import { apiurl } from '@/config';

class _AgentSubscriptionClient {

    

                
            getAll(
                vm:OM.AgentSubscriptionListFilterVm,showSpinner = true): Promise<OM.TablePagedResultOfAgentSubscription> {
                        return CommonServices.defaultPost<OM.TablePagedResultOfAgentSubscription>(apiurl + 'api/AgentSubscription/GetAll', vm,{}, showSpinner );

                    }
    

                
            addNewSubscription(
                vm:OM.AddAgentSubscriptionVm,showSpinner = true): Promise<void> {
                        return CommonServices.defaultPost<void>(apiurl + 'api/AgentSubscription/AddNewSubscription', vm,{}, showSpinner );

                    }
    

                
            getById(
                identifier:string,showSpinner = true): Promise<OM.AgentSubscription> {
                        return CommonServices.defaultGet<OM.AgentSubscription>(apiurl + 'api/AgentSubscription/GetById',{ identifier }, showSpinner);

                    }
    

                
            getActiveSubscription(
                userIdentifier:string,showSpinner = true): Promise<OM.AgentSubscription> {
                        return CommonServices.defaultGet<OM.AgentSubscription>(apiurl + 'api/AgentSubscription/GetActiveSubscription',{ userIdentifier }, showSpinner);

                    }
    

                
            getByUser(
                userIdentifier:string,showSpinner = true): Promise<OM.AgentSubscription[]> {
                        return CommonServices.defaultGet<OM.AgentSubscription[]>(apiurl + 'api/AgentSubscription/GetByUser',{ userIdentifier }, showSpinner);

                    }
    

                
            save(
                item:OM.AgentSubscription,showSpinner = true): Promise<string> {
                        return CommonServices.defaultPost<string>(apiurl + 'api/AgentSubscription/Save', item,{}, showSpinner );

                    }
    

                
            deleteById(
                identifier:string,showSpinner = true): Promise<void> {
                        return CommonServices.defaultGet<void>(apiurl + 'api/AgentSubscription/DeleteById',{ identifier }, showSpinner);

                    }
    

                
            getNewSubscriptionNumber(showSpinner = true): Promise<string> {
                        return CommonServices.defaultGet<string>(apiurl + 'api/AgentSubscription/GetNewSubscriptionNumber',{  }, showSpinner);

                    }
    }

export let AgentSubscriptionClient = new _AgentSubscriptionClient();

class _AgentSubscriptionRequestClient {

    

                
            getAll(
                vm:OM.AgentSubscriptionRequestListFilterVm,showSpinner = true): Promise<OM.TablePagedResultOfAgentSubscriptionRequest> {
                        return CommonServices.defaultPost<OM.TablePagedResultOfAgentSubscriptionRequest>(apiurl + 'api/AgentSubscriptionRequest/GetAll', vm,{}, showSpinner );

                    }
    

                
            getById(
                identifier:string,showSpinner = true): Promise<OM.AgentSubscriptionRequest> {
                        return CommonServices.defaultGet<OM.AgentSubscriptionRequest>(apiurl + 'api/AgentSubscriptionRequest/GetById',{ identifier }, showSpinner);

                    }
    

                
            getPendingByUser(
                userIdentifier:string,showSpinner = true): Promise<OM.AgentSubscriptionRequest> {
                        return CommonServices.defaultGet<OM.AgentSubscriptionRequest>(apiurl + 'api/AgentSubscriptionRequest/GetPendingByUser',{ userIdentifier }, showSpinner);

                    }
    

                
            sendRequest(
                userIdentifier:string,showSpinner = true): Promise<OM.AgentSubscriptionRequest> {
                        return CommonServices.defaultGet<OM.AgentSubscriptionRequest>(apiurl + 'api/AgentSubscriptionRequest/SendRequest',{ userIdentifier }, showSpinner);

                    }
    

                
            save(
                item:OM.AgentSubscriptionRequest,showSpinner = true): Promise<string> {
                        return CommonServices.defaultPost<string>(apiurl + 'api/AgentSubscriptionRequest/Save', item,{}, showSpinner );

                    }
    

                
            approveRequest(
                requestIdentifier:string,showSpinner = true): Promise<void> {
                        return CommonServices.defaultGet<void>(apiurl + 'api/AgentSubscriptionRequest/ApproveRequest',{ requestIdentifier }, showSpinner);

                    }
    

                
            deleteById(
                identifier:string,showSpinner = true): Promise<void> {
                        return CommonServices.defaultGet<void>(apiurl + 'api/AgentSubscriptionRequest/DeleteById',{ identifier }, showSpinner);

                    }
    

                
            removeCommento(
                itemIdentifier:string,
                commentIdentifier:string,showSpinner = true): Promise<void> {
                        return CommonServices.defaultGet<void>(apiurl + 'api/AgentSubscriptionRequest/RemoveCommento',{ itemIdentifier, commentIdentifier }, showSpinner);

                    }
    }

export let AgentSubscriptionRequestClient = new _AgentSubscriptionRequestClient();

class _BackendNotificationClient {

    

                
            countUnread(
                userIdentifier:string,showSpinner = true): Promise<number> {
                        return CommonServices.defaultGet<number>(apiurl + 'api/BackendNotification/CountUnread',{ userIdentifier }, showSpinner);

                    }
    

                
            getByUser(
                userIdentifier:string,
                unreadOnly:boolean,
                skip:number,showSpinner = true): Promise<OM.BaseBackendNotification[]> {
                        return CommonServices.defaultGet<OM.BaseBackendNotification[]>(apiurl + 'api/BackendNotification/GetByUser',{ userIdentifier, unreadOnly, skip }, showSpinner);

                    }
    

                
            setAllRead(
                userIdentifier:string,showSpinner = true): Promise<void> {
                        return CommonServices.defaultGet<void>(apiurl + 'api/BackendNotification/SetAllRead',{ userIdentifier }, showSpinner);

                    }
    

                
            setRead(
                backendNotificationIdentifier:string,showSpinner = true): Promise<void> {
                        return CommonServices.defaultGet<void>(apiurl + 'api/BackendNotification/SetRead',{ backendNotificationIdentifier }, showSpinner);

                    }
    }

export let BackendNotificationClient = new _BackendNotificationClient();

class _BackendRoleConfigClient {

    

                
            getAll(showSpinner = true): Promise<OM.BackendRoleConfig[]> {
                        return CommonServices.defaultGet<OM.BackendRoleConfig[]>(apiurl + 'api/BackendRoleConfig/GetAll',{  }, showSpinner);

                    }
    

                
            getById(
                identifier:string,showSpinner = true): Promise<OM.BackendRoleConfig> {
                        return CommonServices.defaultGet<OM.BackendRoleConfig>(apiurl + 'api/BackendRoleConfig/GetById',{ identifier }, showSpinner);

                    }
    

                
            getByName(
                name:string,showSpinner = true): Promise<OM.BackendRoleConfig> {
                        return CommonServices.defaultGet<OM.BackendRoleConfig>(apiurl + 'api/BackendRoleConfig/GetByName',{ name }, showSpinner);

                    }
    

                
            save(
                item:OM.BackendRoleConfig,showSpinner = true): Promise<string> {
                        return CommonServices.defaultPost<string>(apiurl + 'api/BackendRoleConfig/Save', item,{}, showSpinner );

                    }
    

                
            deleteById(
                identifier:string,showSpinner = true): Promise<void> {
                        return CommonServices.defaultGet<void>(apiurl + 'api/BackendRoleConfig/DeleteById',{ identifier }, showSpinner);

                    }
    

                
            getRoles(showSpinner = true): Promise<string[]> {
                        return CommonServices.defaultGet<string[]>(apiurl + 'api/BackendRoleConfig/GetRoles',{  }, showSpinner);

                    }
    

                
            getPermissionModules(showSpinner = true): Promise<string[]> {
                        return CommonServices.defaultGet<string[]>(apiurl + 'api/BackendRoleConfig/GetPermissionModules',{  }, showSpinner);

                    }
    

                
            getClientModulesByRole(
                role:string,showSpinner = true): Promise<string[]> {
                        return CommonServices.defaultGet<string[]>(apiurl + 'api/BackendRoleConfig/GetClientModulesByRole',{ role }, showSpinner);

                    }
    }

export let BackendRoleConfigClient = new _BackendRoleConfigClient();

class _CardsClient {

    

                
            getAll(
                vm:OM.CardListFilterVm,showSpinner = true): Promise<OM.TablePagedResultOfCard> {
                        return CommonServices.defaultPost<OM.TablePagedResultOfCard>(apiurl + 'api/Cards/GetAll', vm,{}, showSpinner );

                    }
    

                
            getById(
                identifier:string,showSpinner = true): Promise<OM.Card> {
                        return CommonServices.defaultGet<OM.Card>(apiurl + 'api/Cards/GetById',{ identifier }, showSpinner);

                    }
    

                
            getByUser(
                userIdentifier:string,showSpinner = true): Promise<OM.Card[]> {
                        return CommonServices.defaultGet<OM.Card[]>(apiurl + 'api/Cards/GetByUser',{ userIdentifier }, showSpinner);

                    }
    

                
            save(
                item:OM.Card,showSpinner = true): Promise<string> {
                        return CommonServices.defaultPost<string>(apiurl + 'api/Cards/Save', item,{}, showSpinner );

                    }
    

                
            deleteById(
                identifier:string,showSpinner = true): Promise<void> {
                        return CommonServices.defaultGet<void>(apiurl + 'api/Cards/DeleteById',{ identifier }, showSpinner);

                    }
    

                
            exportExcel(showSpinner = true): Promise<OM.NameIdentifier> {
                        return CommonServices.defaultGet<OM.NameIdentifier>(apiurl + 'api/Cards/ExportExcel',{  }, showSpinner);

                    }
    

                
            getAccountBalance(
                userIdentifier:string,
                project:string,showSpinner = true): Promise<string> {
                        return CommonServices.defaultGet<string>(apiurl + 'api/Cards/GetAccountBalance',{ userIdentifier, project }, showSpinner);

                    }
    

                
            get3dsPassword(
                cardIdentifier:string,showSpinner = true): Promise<string> {
                        return CommonServices.defaultGet<string>(apiurl + 'api/Cards/Get3dsPassword',{ cardIdentifier }, showSpinner);

                    }
    

                
            getCardPin(
                cardIdentifier:string,showSpinner = true): Promise<string> {
                        return CommonServices.defaultGet<string>(apiurl + 'api/Cards/GetCardPin',{ cardIdentifier }, showSpinner);

                    }
    

                
            getCardTransactions(
                cardIdentifier:string,
                fromRecord:number,
                recordsCount:number,showSpinner = true): Promise<OM.Transaction[]> {
                        return CommonServices.defaultGet<OM.Transaction[]>(apiurl + 'api/Cards/GetCardTransactions',{ cardIdentifier, fromRecord, recordsCount }, showSpinner);

                    }
    }

export let CardsClient = new _CardsClient();

class _ChatRoomClient {

    

                
            getById(
                identifier:string,showSpinner = true): Promise<OM.ChatRoom> {
                        return CommonServices.defaultGet<OM.ChatRoom>(apiurl + 'api/ChatRoom/GetById',{ identifier }, showSpinner);

                    }
    

                
            getChatInApp(
                userIdentifier:string,
                villageIdentifier:string,showSpinner = true): Promise<OM.ChatRoom> {
                        return CommonServices.defaultGet<OM.ChatRoom>(apiurl + 'api/ChatRoom/GetChatInApp',{ userIdentifier, villageIdentifier }, showSpinner);

                    }
    

                
            checkNewMessagesForUser(
                userIdentifier:string,showSpinner = true): Promise<OM.HasNewChatMessagesVm> {
                        return CommonServices.defaultGet<OM.HasNewChatMessagesVm>(apiurl + 'api/ChatRoom/CheckNewMessagesForUser',{ userIdentifier }, showSpinner);

                    }
    

                
            getChatMessages(
                chatIdentifier:string,
                skip:number,
                take:number,showSpinner = true): Promise<OM.ChatMessage[]> {
                        return CommonServices.defaultGet<OM.ChatMessage[]>(apiurl + 'api/ChatRoom/GetChatMessages',{ chatIdentifier, skip, take }, showSpinner);

                    }
    

                
            getAll(
                vm:OM.TicketListFilterVm,showSpinner = true): Promise<OM.TablePagedResultOfChatRoom> {
                        return CommonServices.defaultPost<OM.TablePagedResultOfChatRoom>(apiurl + 'api/ChatRoom/GetAll', vm,{}, showSpinner );

                    }
    

                
            save(
                item:OM.ChatRoom,showSpinner = true): Promise<string> {
                        return CommonServices.defaultPost<string>(apiurl + 'api/ChatRoom/Save', item,{}, showSpinner );

                    }
    

                
            subscribe(
                identifier:string,
                userIdentifier:string,showSpinner = true): Promise<void> {
                        return CommonServices.defaultGet<void>(apiurl + 'api/ChatRoom/Subscribe',{ identifier, userIdentifier }, showSpinner);

                    }
    

                
            unSubscribe(
                identifier:string,
                userIdentifier:string,showSpinner = true): Promise<void> {
                        return CommonServices.defaultGet<void>(apiurl + 'api/ChatRoom/UnSubscribe',{ identifier, userIdentifier }, showSpinner);

                    }
    

                
            removeMessage(
                messageIdentifier:string,showSpinner = true): Promise<void> {
                        return CommonServices.defaultGet<void>(apiurl + 'api/ChatRoom/RemoveMessage',{ messageIdentifier }, showSpinner);

                    }
    

                
            removeMessageMultiple(
                vm:OM.RemoveChatMessagesVm,showSpinner = true): Promise<void> {
                        return CommonServices.defaultPost<void>(apiurl + 'api/ChatRoom/RemoveMessageMultiple', vm,{}, showSpinner );

                    }
    

                
            deleteChatRoom(
                chatRoomIdentifier:string,showSpinner = true): Promise<void> {
                        return CommonServices.defaultGet<void>(apiurl + 'api/ChatRoom/DeleteChatRoom',{ chatRoomIdentifier }, showSpinner);

                    }
    

                
            disableChat(
                chatIdentifier:string,
                disable:boolean,showSpinner = true): Promise<void> {
                        return CommonServices.defaultGet<void>(apiurl + 'api/ChatRoom/DisableChat',{ chatIdentifier, disable }, showSpinner);

                    }
    }

export let ChatRoomClient = new _ChatRoomClient();

class _ClubSubscriptionClient {

    

                
            getAll(
                vm:OM.ClubSubscriptionListFilterVm,showSpinner = true): Promise<OM.TablePagedResultOfClubSubscription> {
                        return CommonServices.defaultPost<OM.TablePagedResultOfClubSubscription>(apiurl + 'api/ClubSubscription/GetAll', vm,{}, showSpinner );

                    }
    

                
            exportExcel(
                vm:OM.ClubSubscriptionListFilterVm,showSpinner = true): Promise<OM.NameIdentifier> {
                        return CommonServices.defaultPost<OM.NameIdentifier>(apiurl + 'api/ClubSubscription/ExportExcel', vm,{}, showSpinner );

                    }
    

                
            addNewSubscription(
                vm:OM.AddClubSubscriptionVm,showSpinner = true): Promise<void> {
                        return CommonServices.defaultPost<void>(apiurl + 'api/ClubSubscription/AddNewSubscription', vm,{}, showSpinner );

                    }
    

                
            getAllNameIdentifiers(showSpinner = true): Promise<OM.NameIdentifier[]> {
                        return CommonServices.defaultGet<OM.NameIdentifier[]>(apiurl + 'api/ClubSubscription/GetAllNameIdentifiers',{  }, showSpinner);

                    }
    

                
            getById(
                identifier:string,showSpinner = true): Promise<OM.ClubSubscription> {
                        return CommonServices.defaultGet<OM.ClubSubscription>(apiurl + 'api/ClubSubscription/GetById',{ identifier }, showSpinner);

                    }
    

                
            getActiveSubscription(
                userIdentifier:string,showSpinner = true): Promise<OM.ClubSubscription> {
                        return CommonServices.defaultGet<OM.ClubSubscription>(apiurl + 'api/ClubSubscription/GetActiveSubscription',{ userIdentifier }, showSpinner);

                    }
    

                
            getByUser(
                userIdentifier:string,showSpinner = true): Promise<OM.ClubSubscription[]> {
                        return CommonServices.defaultGet<OM.ClubSubscription[]>(apiurl + 'api/ClubSubscription/GetByUser',{ userIdentifier }, showSpinner);

                    }
    

                
            save(
                item:OM.ClubSubscription,showSpinner = true): Promise<string> {
                        return CommonServices.defaultPost<string>(apiurl + 'api/ClubSubscription/Save', item,{}, showSpinner );

                    }
    

                
            deleteById(
                identifier:string,showSpinner = true): Promise<void> {
                        return CommonServices.defaultGet<void>(apiurl + 'api/ClubSubscription/DeleteById',{ identifier }, showSpinner);

                    }
    

                
            getNewSubscriptionNumber(showSpinner = true): Promise<string> {
                        return CommonServices.defaultGet<string>(apiurl + 'api/ClubSubscription/GetNewSubscriptionNumber',{  }, showSpinner);

                    }
    }

export let ClubSubscriptionClient = new _ClubSubscriptionClient();

class _CommissionClient {

    

                
            getAll(
                vm:OM.ProvvigioniListFilterVm,showSpinner = true): Promise<OM.TablePagedResultOfBaseCommission> {
                        return CommonServices.defaultPost<OM.TablePagedResultOfBaseCommission>(apiurl + 'api/Commission/GetAll', vm,{}, showSpinner );

                    }
    

                
            getAllForTable(
                vm:OM.ProvvigioniListFilterVm,showSpinner = true): Promise<OM.TablePagedResultOfBaseCommission> {
                        return CommonServices.defaultPost<OM.TablePagedResultOfBaseCommission>(apiurl + 'api/Commission/GetAllForTable', vm,{}, showSpinner );

                    }
    

                
            exportExcel(
                vm:OM.ProvvigioniListFilterVm,showSpinner = true): Promise<OM.NameIdentifier> {
                        return CommonServices.defaultPost<OM.NameIdentifier>(apiurl + 'api/Commission/ExportExcel', vm,{}, showSpinner );

                    }
    

                
            deleteById(
                identifier:string,showSpinner = true): Promise<void> {
                        return CommonServices.defaultGet<void>(apiurl + 'api/Commission/DeleteById',{ identifier }, showSpinner);

                    }
    

                
            getByWalletTransaction(
                walletTransactionIdentifier:string,showSpinner = true): Promise<OM.BaseCommission[]> {
                        return CommonServices.defaultGet<OM.BaseCommission[]>(apiurl + 'api/Commission/GetByWalletTransaction',{ walletTransactionIdentifier }, showSpinner);

                    }
    }

export let CommissionClient = new _CommissionClient();

class _ContractClient {

    

                
            generateContractsForSubscription(
                subscriptionIdentifier:string,showSpinner = true): Promise<void> {
                        return CommonServices.defaultGet<void>(apiurl + 'api/Contract/GenerateContractsForSubscription',{ subscriptionIdentifier }, showSpinner);

                    }
    

                
            generateContractsForAgentSubscription(
                subscriptionIdentifier:string,showSpinner = true): Promise<void> {
                        return CommonServices.defaultGet<void>(apiurl + 'api/Contract/GenerateContractsForAgentSubscription',{ subscriptionIdentifier }, showSpinner);

                    }
    

                
            signContracts(
                subscriptionIdentifier:string,
                otp:string,showSpinner = true): Promise<string> {
                        return CommonServices.defaultGet<string>(apiurl + 'api/Contract/SignContracts',{ subscriptionIdentifier, otp }, showSpinner);

                    }
    

                
            signContractsAgent(
                subscriptionIdentifier:string,
                otp:string,showSpinner = true): Promise<string> {
                        return CommonServices.defaultGet<string>(apiurl + 'api/Contract/SignContractsAgent',{ subscriptionIdentifier, otp }, showSpinner);

                    }
    }

export let ContractClient = new _ContractClient();

class _DashboardClient {

    

                
            getDashPortafoglio(
                userIdentifier:string,showSpinner = true): Promise<OM.DashboardPortafoglioVm> {
                        return CommonServices.defaultGet<OM.DashboardPortafoglioVm>(apiurl + 'api/Dashboard/GetDashPortafoglio',{ userIdentifier }, showSpinner);

                    }
    

                
            getSaldo(
                userIdentifier:string,showSpinner = true): Promise<number> {
                        return CommonServices.defaultGet<number>(apiurl + 'api/Dashboard/GetSaldo',{ userIdentifier }, showSpinner);

                    }
    

                
            getContatoreAttivi(
                userIdentifier:string,showSpinner = true): Promise<OM.ContatoreAttiviVm> {
                        return CommonServices.defaultGet<OM.ContatoreAttiviVm>(apiurl + 'api/Dashboard/GetContatoreAttivi',{ userIdentifier }, showSpinner);

                    }
    

                
            getDashProfile(
                userIdentifier:string,showSpinner = true): Promise<OM.DashboardProfileVm> {
                        return CommonServices.defaultGet<OM.DashboardProfileVm>(apiurl + 'api/Dashboard/GetDashProfile',{ userIdentifier }, showSpinner);

                    }
    

                
            getDashRicevute(
                userIdentifier:string,showSpinner = true): Promise<OM.WalletUserWithdraw[]> {
                        return CommonServices.defaultGet<OM.WalletUserWithdraw[]>(apiurl + 'api/Dashboard/GetDashRicevute',{ userIdentifier }, showSpinner);

                    }
    

                
            getDashSubUsers(
                userIdentifier:string,showSpinner = true): Promise<OM.UserCardVm[]> {
                        return CommonServices.defaultGet<OM.UserCardVm[]>(apiurl + 'api/Dashboard/GetDashSubUsers',{ userIdentifier }, showSpinner);

                    }
    

                
            hasSubUsers(
                userIdentifier:string,showSpinner = true): Promise<boolean> {
                        return CommonServices.defaultGet<boolean>(apiurl + 'api/Dashboard/HasSubUsers',{ userIdentifier }, showSpinner);

                    }
    

                
            getUserObiettivoCard(
                userIdentifier:string,
                start:string,
                end:string,showSpinner = true): Promise<OM.UserObiettivoCardVm> {
                        return CommonServices.defaultGet<OM.UserObiettivoCardVm>(apiurl + 'api/Dashboard/GetUserObiettivoCard',{ userIdentifier, start, end }, showSpinner);

                    }
    

                
            getSubUserObiettivoCard(
                userIdentifier:string,showSpinner = true): Promise<OM.UserObiettivoCardVm[]> {
                        return CommonServices.defaultGet<OM.UserObiettivoCardVm[]>(apiurl + 'api/Dashboard/GetSubUserObiettivoCard',{ userIdentifier }, showSpinner);

                    }
    

                
            exportDashboards(showSpinner = true): Promise<OM.NameIdentifier> {
                        return CommonServices.defaultGet<OM.NameIdentifier>(apiurl + 'api/Dashboard/ExportDashboards',{  }, showSpinner);

                    }
    }

export let DashboardClient = new _DashboardClient();

class _DeferredPaymentClient {

    

                
            getAll(showSpinner = true): Promise<OM.DeferredPayment[]> {
                        return CommonServices.defaultGet<OM.DeferredPayment[]>(apiurl + 'api/DeferredPayment/GetAll',{  }, showSpinner);

                    }
    

                
            createDeferredPayment(
                vm:OM.CreateDeferredPaymentFromCartVm,showSpinner = true): Promise<string> {
                        return CommonServices.defaultPost<string>(apiurl + 'api/DeferredPayment/CreateDeferredPayment', vm,{}, showSpinner );

                    }
    

                
            createDeferredPaymentFromBackoffice(
                vm:OM.CreateDeferredPaymentFromCartVm,showSpinner = true): Promise<string> {
                        return CommonServices.defaultPost<string>(apiurl + 'api/DeferredPayment/CreateDeferredPaymentFromBackoffice', vm,{}, showSpinner );

                    }
    

                
            createCardTopUp(
                vm:OM.CreateCardTopUpVm,showSpinner = true): Promise<OM.CardTopUp> {
                        return CommonServices.defaultPost<OM.CardTopUp>(apiurl + 'api/DeferredPayment/CreateCardTopUp', vm,{}, showSpinner );

                    }
    

                
            getPendingTopUp(
                cardNumber:string,showSpinner = true): Promise<OM.CardTopUp> {
                        return CommonServices.defaultGet<OM.CardTopUp>(apiurl + 'api/DeferredPayment/GetPendingTopUp',{ cardNumber }, showSpinner);

                    }
    

                
            getPendingByCustomer(
                customerIdentifier:string,showSpinner = true): Promise<OM.DeferredPayment[]> {
                        return CommonServices.defaultGet<OM.DeferredPayment[]>(apiurl + 'api/DeferredPayment/GetPendingByCustomer',{ customerIdentifier }, showSpinner);

                    }
    

                
            getTopUpByCard(
                cardNumber:string,showSpinner = true): Promise<OM.CardTopUp[]> {
                        return CommonServices.defaultGet<OM.CardTopUp[]>(apiurl + 'api/DeferredPayment/GetTopUpByCard',{ cardNumber }, showSpinner);

                    }
    

                
            getByFilterVm(
                vm:OM.PagamentoBonificoListFilterVm,showSpinner = true): Promise<OM.TablePagedResultOfDeferredPayment> {
                        return CommonServices.defaultPost<OM.TablePagedResultOfDeferredPayment>(apiurl + 'api/DeferredPayment/GetByFilterVm', vm,{}, showSpinner );

                    }
    

                
            getById(
                identifier:string,showSpinner = true): Promise<OM.DeferredPayment> {
                        return CommonServices.defaultGet<OM.DeferredPayment>(apiurl + 'api/DeferredPayment/GetById',{ identifier }, showSpinner);

                    }
    

                
            save(
                pagamento:OM.DeferredPayment,showSpinner = true): Promise<void> {
                        return CommonServices.defaultPost<void>(apiurl + 'api/DeferredPayment/Save', pagamento,{}, showSpinner );

                    }
    

                
            confermaPagamento(
                identifier:string,showSpinner = true): Promise<void> {
                        return CommonServices.defaultGet<void>(apiurl + 'api/DeferredPayment/ConfermaPagamento',{ identifier }, showSpinner);

                    }
    

                
            delete(
                identifier:string,showSpinner = true): Promise<void> {
                        return CommonServices.defaultGet<void>(apiurl + 'api/DeferredPayment/Delete',{ identifier }, showSpinner);

                    }
    

                
            annullaPagamentoBonifico(
                deferredPaymentIdentifier:string,showSpinner = true): Promise<void> {
                        return CommonServices.defaultGet<void>(apiurl + 'api/DeferredPayment/AnnullaPagamentoBonifico',{ deferredPaymentIdentifier }, showSpinner);

                    }
    

                
            cancelDeferredPayment(
                deferredPaymentIdentifier:string,showSpinner = true): Promise<void> {
                        return CommonServices.defaultGet<void>(apiurl + 'api/DeferredPayment/CancelDeferredPayment',{ deferredPaymentIdentifier }, showSpinner);

                    }
    

                
            removeCommento(
                itemIdentifier:string,
                commentIdentifier:string,showSpinner = true): Promise<void> {
                        return CommonServices.defaultGet<void>(apiurl + 'api/DeferredPayment/RemoveCommento',{ itemIdentifier, commentIdentifier }, showSpinner);

                    }
    

                
            removeCommentoInterno(
                itemIdentifier:string,
                commentIdentifier:string,showSpinner = true): Promise<void> {
                        return CommonServices.defaultGet<void>(apiurl + 'api/DeferredPayment/RemoveCommentoInterno',{ itemIdentifier, commentIdentifier }, showSpinner);

                    }
    }

export let DeferredPaymentClient = new _DeferredPaymentClient();

class _FaqNodeClient {

    

                
            getById(
                faqNodeIdentifier:string,showSpinner = true): Promise<OM.FaqNode> {
                        return CommonServices.defaultGet<OM.FaqNode>(apiurl + 'api/FaqNode/GetById',{ faqNodeIdentifier }, showSpinner);

                    }
    

                
            save(
                item:OM.FaqNode,showSpinner = true): Promise<string> {
                        return CommonServices.defaultPost<string>(apiurl + 'api/FaqNode/Save', item,{}, showSpinner );

                    }
    

                
            addAnswerToNode(
                nodeIdentifier:string,showSpinner = true): Promise<OM.FaqNodeText> {
                        return CommonServices.defaultGet<OM.FaqNodeText>(apiurl + 'api/FaqNode/AddAnswerToNode',{ nodeIdentifier }, showSpinner);

                    }
    

                
            removeAnswerToNode(
                nodeIdentifier:string,
                answerIdentifier:string,showSpinner = true): Promise<void> {
                        return CommonServices.defaultGet<void>(apiurl + 'api/FaqNode/RemoveAnswerToNode',{ nodeIdentifier, answerIdentifier }, showSpinner);

                    }
    

                
            getRoot(showSpinner = true): Promise<OM.FaqNode> {
                        return CommonServices.defaultGet<OM.FaqNode>(apiurl + 'api/FaqNode/GetRoot',{  }, showSpinner);

                    }
    }

export let FaqNodeClient = new _FaqNodeClient();

class _GalleryItemCreditWalletClient {

    

                
            getBalanceOfUser(
                userIdentifier:string,showSpinner = true): Promise<number> {
                        return CommonServices.defaultGet<number>(apiurl + 'api/GalleryItemCreditWallet/GetBalanceOfUser',{ userIdentifier }, showSpinner);

                    }
    }

export let GalleryItemCreditWalletClient = new _GalleryItemCreditWalletClient();

class _InAppNotificationClient {

    

                
            countUnread(
                userIdentifier:string,showSpinner = true): Promise<number> {
                        return CommonServices.defaultGet<number>(apiurl + 'api/InAppNotification/CountUnread',{ userIdentifier }, showSpinner);

                    }
    

                
            getByCliente(
                userIdentifier:string,showSpinner = true): Promise<OM.InAppNotification[]> {
                        return CommonServices.defaultGet<OM.InAppNotification[]>(apiurl + 'api/InAppNotification/GetByCliente',{ userIdentifier }, showSpinner);

                    }
    

                
            getNextByCliente(
                userIdentifier:string,showSpinner = true): Promise<OM.InAppNotification> {
                        return CommonServices.defaultGet<OM.InAppNotification>(apiurl + 'api/InAppNotification/GetNextByCliente',{ userIdentifier }, showSpinner);

                    }
    

                
            setRead(
                notificationIdentifier:string,showSpinner = true): Promise<void> {
                        return CommonServices.defaultGet<void>(apiurl + 'api/InAppNotification/SetRead',{ notificationIdentifier }, showSpinner);

                    }
    

                
            getUnreadCountByUser(
                userIdentifier:string,showSpinner = true): Promise<number> {
                        return CommonServices.defaultGet<number>(apiurl + 'api/InAppNotification/GetUnreadCountByUser',{ userIdentifier }, showSpinner);

                    }
    

                
            getAllByUser(
                userIdentifier:string,showSpinner = true): Promise<OM.InAppNotification[]> {
                        return CommonServices.defaultGet<OM.InAppNotification[]>(apiurl + 'api/InAppNotification/GetAllByUser',{ userIdentifier }, showSpinner);

                    }
    

                
            setAllRead(
                userIdentifier:string,showSpinner = true): Promise<void> {
                        return CommonServices.defaultGet<void>(apiurl + 'api/InAppNotification/SetAllRead',{ userIdentifier }, showSpinner);

                    }
    }

export let InAppNotificationClient = new _InAppNotificationClient();

class _LocalizedClient {

    

                
            saveAnonymousLocalizedValue(
                item:OM.KeyValuePairOfStringAndString,showSpinner = true): Promise<void> {
                        return CommonServices.defaultPost<void>(apiurl + 'api/Localized/SaveAnonymousLocalizedValue', item,{}, showSpinner );

                    }
    

                
            saveLocalizedEntity(
                item:OM.LocalizedEntity,showSpinner = true): Promise<string> {
                        return CommonServices.defaultPost<string>(apiurl + 'api/Localized/SaveLocalizedEntity', item,{}, showSpinner );

                    }
    

                
            getAll(showSpinner = true): Promise<OM.LocalizedEntity[]> {
                        return CommonServices.defaultGet<OM.LocalizedEntity[]>(apiurl + 'api/Localized/GetAll',{  }, showSpinner);

                    }
    

                
            getEnabledLanguages(showSpinner = true): Promise<string[]> {
                        return CommonServices.defaultGet<string[]>(apiurl + 'api/Localized/GetEnabledLanguages',{  }, showSpinner);

                    }
    

                
            getSupportedLanguages(showSpinner = true): Promise<string[]> {
                        return CommonServices.defaultGet<string[]>(apiurl + 'api/Localized/GetSupportedLanguages',{  }, showSpinner);

                    }
    

                
            saveLocalizedValue(
                item:OM.KeyValuePairOfStringAndString,showSpinner = true): Promise<void> {
                        return CommonServices.defaultPost<void>(apiurl + 'api/Localized/SaveLocalizedValue', item,{}, showSpinner );

                    }
    

                
            editLocalizedValue(
                value:OM.LocalizedEntity,showSpinner = true): Promise<void> {
                        return CommonServices.defaultPost<void>(apiurl + 'api/Localized/EditLocalizedValue', value,{}, showSpinner );

                    }
    }

export let LocalizedClient = new _LocalizedClient();

class _LoginClient {

    

                
            login(
                vm:OM.LoginVm,showSpinner = true): Promise<OM.LoginData> {
                        return CommonServices.defaultPost<OM.LoginData>(apiurl + 'api/Login/Login', vm,{}, showSpinner );

                    }
    

                
            loginWithTempPassword(
                vm:OM.LoginVm,showSpinner = true): Promise<OM.LoginData> {
                        return CommonServices.defaultPost<OM.LoginData>(apiurl + 'api/Login/LoginWithTempPassword', vm,{}, showSpinner );

                    }
    

                
            switchToAccount(
                userIdentifier:string,showSpinner = true): Promise<OM.LoginData> {
                        return CommonServices.defaultGet<OM.LoginData>(apiurl + 'api/Login/SwitchToAccount',{ userIdentifier }, showSpinner);

                    }
    

                
            loginAsUser(
                userIdentifier:string,showSpinner = true): Promise<OM.LoginData> {
                        return CommonServices.defaultGet<OM.LoginData>(apiurl + 'api/Login/LoginAsUser',{ userIdentifier }, showSpinner);

                    }
    

                
            getLoginDataFromToken(showSpinner = true): Promise<OM.LoginData> {
                        return CommonServices.defaultGet<OM.LoginData>(apiurl + 'api/Login/GetLoginDataFromToken',{  }, showSpinner);

                    }
    

                
            checkEmailAvailable(
                email:string,showSpinner = true): Promise<boolean> {
                        return CommonServices.defaultGet<boolean>(apiurl + 'api/Login/CheckEmailAvailable',{ email }, showSpinner);

                    }
    

                
            register(
                vm:OM.RegisterVm,showSpinner = true): Promise<void> {
                        return CommonServices.defaultPost<void>(apiurl + 'api/Login/Register', vm,{}, showSpinner );

                    }
    

                
            sendSmsPassword(
                username:string,showSpinner = true): Promise<void> {
                        return CommonServices.defaultGet<void>(apiurl + 'api/Login/SendSmsPassword',{ username }, showSpinner);

                    }
    

                
            setNewPassword(
                password:string,showSpinner = true): Promise<void> {
                        return CommonServices.defaultGet<void>(apiurl + 'api/Login/SetNewPassword',{ password }, showSpinner);

                    }
    

                
            loginFromGoogle(
                vm:OM.OAuthSignInVm,showSpinner = true): Promise<OM.LoginData> {
                        return CommonServices.defaultPost<OM.LoginData>(apiurl + 'api/Login/LoginFromGoogle', vm,{}, showSpinner );

                    }
    

                
            loginFromApple(
                vm:OM.AppleSignInVm,showSpinner = true): Promise<OM.LoginData> {
                        return CommonServices.defaultPost<OM.LoginData>(apiurl + 'api/Login/LoginFromApple', vm,{}, showSpinner );

                    }
    

                
            refreshLogin(showSpinner = true): Promise<OM.LoginData> {
                        return CommonServices.defaultGet<OM.LoginData>(apiurl + 'api/Login/RefreshLogin',{  }, showSpinner);

                    }
    }

export let LoginClient = new _LoginClient();

class _MailEventClient {

    

                
            getMailEvents(showSpinner = true): Promise<OM.MailEventDefinition[]> {
                        return CommonServices.defaultGet<OM.MailEventDefinition[]>(apiurl + 'api/MailEvent/GetMailEvents',{  }, showSpinner);

                    }
    

                
            getByName(
                name:string,showSpinner = true): Promise<OM.MailEventDefinition> {
                        return CommonServices.defaultGet<OM.MailEventDefinition>(apiurl + 'api/MailEvent/GetByName',{ name }, showSpinner);

                    }
    }

export let MailEventClient = new _MailEventClient();

class _MailSentLogClient {

    

                
            getAllPaginated(
                vm:OM.MailSentLogListFilterVm,showSpinner = true): Promise<OM.TablePagedResultOfMailSentLog> {
                        return CommonServices.defaultPost<OM.TablePagedResultOfMailSentLog>(apiurl + 'api/MailSentLog/GetAllPaginated', vm,{}, showSpinner );

                    }
    }

export let MailSentLogClient = new _MailSentLogClient();

class _MessageOfTheDayClient {

    

                
            getAll(showSpinner = true): Promise<OM.MessageOfTheDay[]> {
                        return CommonServices.defaultGet<OM.MessageOfTheDay[]>(apiurl + 'api/MessageOfTheDay/GetAll',{  }, showSpinner);

                    }
    

                
            getMessageOfTheDay(showSpinner = true): Promise<OM.MessageOfTheDay> {
                        return CommonServices.defaultGet<OM.MessageOfTheDay>(apiurl + 'api/MessageOfTheDay/GetMessageOfTheDay',{  }, showSpinner);

                    }
    

                
            save(
                item:OM.MessageOfTheDay,showSpinner = true): Promise<string> {
                        return CommonServices.defaultPost<string>(apiurl + 'api/MessageOfTheDay/Save', item,{}, showSpinner );

                    }
    

                
            delete(
                identifier:string,showSpinner = true): Promise<void> {
                        return CommonServices.defaultGet<void>(apiurl + 'api/MessageOfTheDay/Delete',{ identifier }, showSpinner);

                    }
    }

export let MessageOfTheDayClient = new _MessageOfTheDayClient();

class _NetworkClient {

    

                
            getDescendants(
                userIdentifier:string,
                showClienti:boolean,
                showLead:boolean,showSpinner = true): Promise<OM.NetworkUserVm[]> {
                        return CommonServices.defaultGet<OM.NetworkUserVm[]>(apiurl + 'api/Network/GetDescendants',{ userIdentifier, showClienti, showLead }, showSpinner);

                    }
    

                
            getNetworkUser(
                userIdentifier:string,showSpinner = true): Promise<OM.NetworkUserVm> {
                        return CommonServices.defaultGet<OM.NetworkUserVm>(apiurl + 'api/Network/GetNetworkUser',{ userIdentifier }, showSpinner);

                    }
    

                
            getFirstLineOf(
                userIdentifier:string,showSpinner = true): Promise<OM.NetworkUserVm[]> {
                        return CommonServices.defaultGet<OM.NetworkUserVm[]>(apiurl + 'api/Network/GetFirstLineOf',{ userIdentifier }, showSpinner);

                    }
    

                
            countFirstLine(
                userIdentifier:string,
                onlyActive:boolean,showSpinner = true): Promise<number> {
                        return CommonServices.defaultGet<number>(apiurl + 'api/Network/CountFirstLine',{ userIdentifier, onlyActive }, showSpinner);

                    }
    

                
            countAllDescendant(
                userIdentifier:string,
                onlyActive:boolean,showSpinner = true): Promise<number> {
                        return CommonServices.defaultGet<number>(apiurl + 'api/Network/CountAllDescendant',{ userIdentifier, onlyActive }, showSpinner);

                    }
    }

export let NetworkClient = new _NetworkClient();

class _NewsFeedItemClient {

    

                
            getAll(showSpinner = true): Promise<OM.NewsFeedItem[]> {
                        return CommonServices.defaultGet<OM.NewsFeedItem[]>(apiurl + 'api/NewsFeedItem/GetAll',{  }, showSpinner);

                    }
    

                
            getPublished(showSpinner = true): Promise<OM.NewsFeedItemListVm[]> {
                        return CommonServices.defaultGet<OM.NewsFeedItemListVm[]>(apiurl + 'api/NewsFeedItem/GetPublished',{  }, showSpinner);

                    }
    

                
            getById(
                identifier:string,showSpinner = true): Promise<OM.NewsFeedItem> {
                        return CommonServices.defaultGet<OM.NewsFeedItem>(apiurl + 'api/NewsFeedItem/GetById',{ identifier }, showSpinner);

                    }
    

                
            deleteById(
                identifier:string,showSpinner = true): Promise<void> {
                        return CommonServices.defaultGet<void>(apiurl + 'api/NewsFeedItem/DeleteById',{ identifier }, showSpinner);

                    }
    

                
            save(
                item:OM.NewsFeedItem,showSpinner = true): Promise<string> {
                        return CommonServices.defaultPost<string>(apiurl + 'api/NewsFeedItem/Save', item,{}, showSpinner );

                    }
    }

export let NewsFeedItemClient = new _NewsFeedItemClient();

class _OtpSignClient {

    

                
            sendOtpByMail(
                userIdentifier:string,showSpinner = true): Promise<void> {
                        return CommonServices.defaultGet<void>(apiurl + 'api/OtpSign/SendOtpByMail',{ userIdentifier }, showSpinner);

                    }
    

                
            sendOtpBySms(
                userIdentifier:string,showSpinner = true): Promise<void> {
                        return CommonServices.defaultGet<void>(apiurl + 'api/OtpSign/SendOtpBySms',{ userIdentifier }, showSpinner);

                    }
    

                
            hasOtpPending(
                userIdentifier:string,showSpinner = true): Promise<boolean> {
                        return CommonServices.defaultGet<boolean>(apiurl + 'api/OtpSign/HasOtpPending',{ userIdentifier }, showSpinner);

                    }
    

                
            canResend(
                userIdentifier:string,showSpinner = true): Promise<number> {
                        return CommonServices.defaultGet<number>(apiurl + 'api/OtpSign/CanResend',{ userIdentifier }, showSpinner);

                    }
    }

export let OtpSignClient = new _OtpSignClient();

class _PdfInterpolationTemplateClient {

    

                
            getTemplateNames(showSpinner = true): Promise<string[]> {
                        return CommonServices.defaultGet<string[]>(apiurl + 'api/PdfInterpolationTemplate/GetTemplateNames',{  }, showSpinner);

                    }
    

                
            getVariables(
                templateName:string,showSpinner = true): Promise<string[]> {
                        return CommonServices.defaultGet<string[]>(apiurl + 'api/PdfInterpolationTemplate/GetVariables',{ templateName }, showSpinner);

                    }
    

                
            save(
                template:OM.PdfInterpolationTemplate,showSpinner = true): Promise<string> {
                        return CommonServices.defaultPost<string>(apiurl + 'api/PdfInterpolationTemplate/Save', template,{}, showSpinner );

                    }
    

                
            getAll(showSpinner = true): Promise<OM.PdfInterpolationTemplate[]> {
                        return CommonServices.defaultGet<OM.PdfInterpolationTemplate[]>(apiurl + 'api/PdfInterpolationTemplate/GetAll',{  }, showSpinner);

                    }
    

                
            getById(
                identifier:string,showSpinner = true): Promise<OM.PdfInterpolationTemplate> {
                        return CommonServices.defaultGet<OM.PdfInterpolationTemplate>(apiurl + 'api/PdfInterpolationTemplate/GetById',{ identifier }, showSpinner);

                    }
    

                
            deleteById(
                identifier:string,showSpinner = true): Promise<void> {
                        return CommonServices.defaultGet<void>(apiurl + 'api/PdfInterpolationTemplate/DeleteById',{ identifier }, showSpinner);

                    }
    

                
            toggleActive(
                identifier:string,showSpinner = true): Promise<void> {
                        return CommonServices.defaultGet<void>(apiurl + 'api/PdfInterpolationTemplate/ToggleActive',{ identifier }, showSpinner);

                    }
    }

export let PdfInterpolationTemplateClient = new _PdfInterpolationTemplateClient();

class _PhotoPrintRequestClient {

    

                
            getAll(
                villageIdentifier:string,showSpinner = true): Promise<OM.PhotoPrintRequest[]> {
                        return CommonServices.defaultGet<OM.PhotoPrintRequest[]>(apiurl + 'api/PhotoPrintRequest/GetAll',{ villageIdentifier }, showSpinner);

                    }
    

                
            getPhotoPrintRequestExisting(
                villageGalleryItemIdentifier:string,showSpinner = true): Promise<OM.PhotoPrintRequest> {
                        return CommonServices.defaultGet<OM.PhotoPrintRequest>(apiurl + 'api/PhotoPrintRequest/GetPhotoPrintRequestExisting',{ villageGalleryItemIdentifier }, showSpinner);

                    }
    

                
            createPhotoPrintRequest(
                villageGalleryItemIdentifier:string,showSpinner = true): Promise<void> {
                        return CommonServices.defaultGet<void>(apiurl + 'api/PhotoPrintRequest/CreatePhotoPrintRequest',{ villageGalleryItemIdentifier }, showSpinner);

                    }
    

                
            cancelPhotoPrintRequest(
                villageGalleryItemIdentifier:string,showSpinner = true): Promise<void> {
                        return CommonServices.defaultGet<void>(apiurl + 'api/PhotoPrintRequest/CancelPhotoPrintRequest',{ villageGalleryItemIdentifier }, showSpinner);

                    }
    

                
            getById(
                identifier:string,showSpinner = true): Promise<OM.PhotoPrintRequest> {
                        return CommonServices.defaultGet<OM.PhotoPrintRequest>(apiurl + 'api/PhotoPrintRequest/GetById',{ identifier }, showSpinner);

                    }
    

                
            save(
                item:OM.PhotoPrintRequest,showSpinner = true): Promise<void> {
                        return CommonServices.defaultPost<void>(apiurl + 'api/PhotoPrintRequest/Save', item,{}, showSpinner );

                    }
    

                
            removeCommento(
                itemIdentifier:string,
                commentIdentifier:string,showSpinner = true): Promise<void> {
                        return CommonServices.defaultGet<void>(apiurl + 'api/PhotoPrintRequest/RemoveCommento',{ itemIdentifier, commentIdentifier }, showSpinner);

                    }
    

                
            deleteById(
                identifier:string,showSpinner = true): Promise<void> {
                        return CommonServices.defaultPost<void>(apiurl + 'api/PhotoPrintRequest/DeleteById', identifier,{}, showSpinner );

                    }
    }

export let PhotoPrintRequestClient = new _PhotoPrintRequestClient();

class _ProjectConfigClient {

    

                
            getAll(showSpinner = true): Promise<OM.ProjectConfig[]> {
                        return CommonServices.defaultGet<OM.ProjectConfig[]>(apiurl + 'api/ProjectConfig/GetAll',{  }, showSpinner);

                    }
    

                
            getConfig(showSpinner = true): Promise<OM.ProjectConfig> {
                        return CommonServices.defaultGet<OM.ProjectConfig>(apiurl + 'api/ProjectConfig/GetConfig',{  }, showSpinner);

                    }
    

                
            getHtmlBlockTypes(showSpinner = true): Promise<string[]> {
                        return CommonServices.defaultGet<string[]>(apiurl + 'api/ProjectConfig/GetHtmlBlockTypes',{  }, showSpinner);

                    }
    

                
            getAuraCoinValue(showSpinner = true): Promise<number> {
                        return CommonServices.defaultGet<number>(apiurl + 'api/ProjectConfig/GetAuraCoinValue',{  }, showSpinner);

                    }
    

                
            getMembershipLandingPage(showSpinner = true): Promise<OM.MembershipLandingPage> {
                        return CommonServices.defaultGet<OM.MembershipLandingPage>(apiurl + 'api/ProjectConfig/GetMembershipLandingPage',{  }, showSpinner);

                    }
    

                
            getNeedsFiscalCode(showSpinner = true): Promise<boolean> {
                        return CommonServices.defaultGet<boolean>(apiurl + 'api/ProjectConfig/GetNeedsFiscalCode',{  }, showSpinner);

                    }
    

                
            getPaymentMethods(showSpinner = true): Promise<OM.PaymentMethodDetails[]> {
                        return CommonServices.defaultGet<OM.PaymentMethodDetails[]>(apiurl + 'api/ProjectConfig/GetPaymentMethods',{  }, showSpinner);

                    }
    

                
            getPaymentRequestMethods(showSpinner = true): Promise<OM.PaymentRequestMethodDetails[]> {
                        return CommonServices.defaultGet<OM.PaymentRequestMethodDetails[]>(apiurl + 'api/ProjectConfig/GetPaymentRequestMethods',{  }, showSpinner);

                    }
    

                
            getPaymentRequestConfig(showSpinner = true): Promise<OM.PaymentRequestConfig> {
                        return CommonServices.defaultGet<OM.PaymentRequestConfig>(apiurl + 'api/ProjectConfig/GetPaymentRequestConfig',{  }, showSpinner);

                    }
    

                
            getScratchAndWinRules(showSpinner = true): Promise<OM.LocalizedValue> {
                        return CommonServices.defaultGet<OM.LocalizedValue>(apiurl + 'api/ProjectConfig/GetScratchAndWinRules',{  }, showSpinner);

                    }
    

                
            getScratchAndWinShortRules(showSpinner = true): Promise<OM.LocalizedValue> {
                        return CommonServices.defaultGet<OM.LocalizedValue>(apiurl + 'api/ProjectConfig/GetScratchAndWinShortRules',{  }, showSpinner);

                    }
    

                
            getProjectConfigVm(
                project:string,showSpinner = true): Promise<OM.ProjectConfigVm> {
                        return CommonServices.defaultGet<OM.ProjectConfigVm>(apiurl + 'api/ProjectConfig/GetProjectConfigVm',{ project }, showSpinner);

                    }
    

                
            save(
                item:OM.ProjectConfig,showSpinner = true): Promise<string> {
                        return CommonServices.defaultPost<string>(apiurl + 'api/ProjectConfig/Save', item,{}, showSpinner );

                    }
    

                
            sendTestEmail(
                email:string,showSpinner = true): Promise<OM.ProjectColors> {
                        return CommonServices.defaultGet<OM.ProjectColors>(apiurl + 'api/ProjectConfig/SendTestEmail',{ email }, showSpinner);

                    }
    

                
            getProjectColors(showSpinner = true): Promise<OM.ProjectColors> {
                        return CommonServices.defaultGet<OM.ProjectColors>(apiurl + 'api/ProjectConfig/GetProjectColors',{  }, showSpinner);

                    }
    

                
            getStatuses(showSpinner = true): Promise<string[]> {
                        return CommonServices.defaultGet<string[]>(apiurl + 'api/ProjectConfig/GetStatuses',{  }, showSpinner);

                    }
    

                
            getSubStatuses(showSpinner = true): Promise<string[]> {
                        return CommonServices.defaultGet<string[]>(apiurl + 'api/ProjectConfig/GetSubStatuses',{  }, showSpinner);

                    }
    

                
            getProjectUrl(showSpinner = true): Promise<OM.UrlConfig> {
                        return CommonServices.defaultGet<OM.UrlConfig>(apiurl + 'api/ProjectConfig/GetProjectUrl',{  }, showSpinner);

                    }
    

                
            getPaymentConfigVm(showSpinner = true): Promise<OM.PaymentConfigVm> {
                        return CommonServices.defaultGet<OM.PaymentConfigVm>(apiurl + 'api/ProjectConfig/GetPaymentConfigVm',{  }, showSpinner);

                    }
    

                
            canRequestPayment(showSpinner = true): Promise<OM.CanRequestPaymentVm> {
                        return CommonServices.defaultGet<OM.CanRequestPaymentVm>(apiurl + 'api/ProjectConfig/CanRequestPayment',{  }, showSpinner);

                    }
    

                
            canOpenTicketV2(showSpinner = true): Promise<OM.GetOrariAperturaTicketVm> {
                        return CommonServices.defaultGet<OM.GetOrariAperturaTicketVm>(apiurl + 'api/ProjectConfig/CanOpenTicketV2',{  }, showSpinner);

                    }
    

                
            getPaymentRequestMinimumAmount(showSpinner = true): Promise<number> {
                        return CommonServices.defaultGet<number>(apiurl + 'api/ProjectConfig/GetPaymentRequestMinimumAmount',{  }, showSpinner);

                    }
    

                
            getPhonePrefixes(showSpinner = true): Promise<OM.PrefixCountry[]> {
                        return CommonServices.defaultGet<OM.PrefixCountry[]>(apiurl + 'api/ProjectConfig/GetPhonePrefixes',{  }, showSpinner);

                    }
    

                
            getCountryNames(showSpinner = true): Promise<string[]> {
                        return CommonServices.defaultGet<string[]>(apiurl + 'api/ProjectConfig/GetCountryNames',{  }, showSpinner);

                    }
    

                
            swaggetModelFiller(showSpinner = true): Promise<OM.SwaggerModelFiller> {
                        return CommonServices.defaultGet<OM.SwaggerModelFiller>(apiurl + 'api/ProjectConfig/SwaggetModelFiller',{  }, showSpinner);

                    }
    }

export let ProjectConfigClient = new _ProjectConfigClient();

class _PurchaseClient {

    

                
            getByCliente(
                clienteIdentifier:string,
                showHiddenToCustomer:boolean,showSpinner = true): Promise<OM.Purchase[]> {
                        return CommonServices.defaultGet<OM.Purchase[]>(apiurl + 'api/Purchase/GetByCliente',{ clienteIdentifier, showHiddenToCustomer }, showSpinner);

                    }
    

                
            getById(
                identifier:string,showSpinner = true): Promise<OM.Purchase> {
                        return CommonServices.defaultGet<OM.Purchase>(apiurl + 'api/Purchase/GetById',{ identifier }, showSpinner);

                    }
    

                
            buyWithSaldo(
                vm:OM.CreateDeferredPaymentFromCartVm,showSpinner = true): Promise<OM.Purchase> {
                        return CommonServices.defaultPost<OM.Purchase>(apiurl + 'api/Purchase/BuyWithSaldo', vm,{}, showSpinner );

                    }
    

                
            makePurchaseManually(
                vm:OM.MakePurchaseManuallyVm,showSpinner = true): Promise<OM.Purchase> {
                        return CommonServices.defaultPost<OM.Purchase>(apiurl + 'api/Purchase/MakePurchaseManually', vm,{}, showSpinner );

                    }
    

                
            saveStorno(
                purchaseIdentifier:string,showSpinner = true): Promise<void> {
                        return CommonServices.defaultGet<void>(apiurl + 'api/Purchase/SaveStorno',{ purchaseIdentifier }, showSpinner);

                    }
    

                
            getByFilterVm(
                vm:OM.PurchaseListFilterVm,showSpinner = true): Promise<OM.TablePagedResultOfPurchase> {
                        return CommonServices.defaultPost<OM.TablePagedResultOfPurchase>(apiurl + 'api/Purchase/GetByFilterVm', vm,{}, showSpinner );

                    }
    

                
            getFatturatoByPeriod(
                fromDate:string,
                toDate:string,
                userIdentifier:string,showSpinner = true): Promise<number> {
                        return CommonServices.defaultGet<number>(apiurl + 'api/Purchase/GetFatturatoByPeriod',{ fromDate, toDate, userIdentifier }, showSpinner);

                    }
    

                
            exportExcel(
                vm:OM.PurchaseListFilterVm,showSpinner = true): Promise<OM.NameIdentifier> {
                        return CommonServices.defaultPost<OM.NameIdentifier>(apiurl + 'api/Purchase/ExportExcel', vm,{}, showSpinner );

                    }
    

                
            delete(
                identifier:string,showSpinner = true): Promise<void> {
                        return CommonServices.defaultGet<void>(apiurl + 'api/Purchase/Delete',{ identifier }, showSpinner);

                    }
    

                
            downloadCustomerReceipt(
                purchaseIdentifier:string,showSpinner = true): Promise<OM.NameIdentifier> {
                        return CommonServices.defaultGet<OM.NameIdentifier>(apiurl + 'api/Purchase/DownloadCustomerReceipt',{ purchaseIdentifier }, showSpinner);

                    }
    }

export let PurchaseClient = new _PurchaseClient();

class _PushNotificationClient {

    

                
            sendPushToUserList(
                vm:OM.SendPushToListVm,showSpinner = true): Promise<void> {
                        return CommonServices.defaultPost<void>(apiurl + 'api/PushNotification/SendPushToUserList', vm,{}, showSpinner );

                    }
    }

export let PushNotificationClient = new _PushNotificationClient();

class _PushSentLogClient {

    

                
            getAllPaginated(
                vm:OM.PushSentLogListFilterVm,showSpinner = true): Promise<OM.TablePagedResultOfPushSentLog> {
                        return CommonServices.defaultPost<OM.TablePagedResultOfPushSentLog>(apiurl + 'api/PushSentLog/GetAllPaginated', vm,{}, showSpinner );

                    }
    }

export let PushSentLogClient = new _PushSentLogClient();

class _QualificationConfigClient {

    

                
            getQualifiche(showSpinner = true): Promise<OM.QualificationConfig[]> {
                        return CommonServices.defaultGet<OM.QualificationConfig[]>(apiurl + 'api/QualificationConfig/GetQualifiche',{  }, showSpinner);

                    }
    

                
            saveAll(
                items:OM.QualificationConfig[],showSpinner = true): Promise<void> {
                        return CommonServices.defaultPost<void>(apiurl + 'api/QualificationConfig/SaveAll', items,{}, showSpinner );

                    }
    

                
            deleteById(
                identifier:string,showSpinner = true): Promise<void> {
                        return CommonServices.defaultGet<void>(apiurl + 'api/QualificationConfig/DeleteById',{ identifier }, showSpinner);

                    }
    }

export let QualificationConfigClient = new _QualificationConfigClient();

class _SmsEventClient {

    

                
            getSmsEvents(showSpinner = true): Promise<OM.SmsEventDefinition[]> {
                        return CommonServices.defaultGet<OM.SmsEventDefinition[]>(apiurl + 'api/SmsEvent/GetSmsEvents',{  }, showSpinner);

                    }
    

                
            getByName(
                name:string,showSpinner = true): Promise<OM.SmsEventDefinition> {
                        return CommonServices.defaultGet<OM.SmsEventDefinition>(apiurl + 'api/SmsEvent/GetByName',{ name }, showSpinner);

                    }
    }

export let SmsEventClient = new _SmsEventClient();

class _SmsSentLogClient {

    

                
            getAllPaginated(
                vm:OM.SmsSentLogListFilterVm,showSpinner = true): Promise<OM.TablePagedResultOfSmsSentLog> {
                        return CommonServices.defaultPost<OM.TablePagedResultOfSmsSentLog>(apiurl + 'api/SmsSentLog/GetAllPaginated', vm,{}, showSpinner );

                    }
    }

export let SmsSentLogClient = new _SmsSentLogClient();

class _StripeClient {

    

                
            checkPaymentDone(
                sessionId:string,showSpinner = true): Promise<string> {
                        return CommonServices.defaultGet<string>(apiurl + 'api/Stripe/CheckPaymentDone',{ sessionId }, showSpinner);

                    }
    

                
            createClientPaymentConfigForCart(
                userIdentifier:string,showSpinner = true): Promise<OM.StripeClientPaymentConfig> {
                        return CommonServices.defaultGet<OM.StripeClientPaymentConfig>(apiurl + 'api/Stripe/CreateClientPaymentConfigForCart',{ userIdentifier }, showSpinner);

                    }
    

                
            createClientPaymentConfigForInstallment(
                userIdentifier:string,
                subscriptionIdentifier:string,showSpinner = true): Promise<OM.StripeClientPaymentConfig> {
                        return CommonServices.defaultGet<OM.StripeClientPaymentConfig>(apiurl + 'api/Stripe/CreateClientPaymentConfigForInstallment',{ userIdentifier, subscriptionIdentifier }, showSpinner);

                    }
    

                
            createSessionForCart(
                cart:OM.ShoppingCart,showSpinner = true): Promise<string> {
                        return CommonServices.defaultPost<string>(apiurl + 'api/Stripe/CreateSessionForCart', cart,{}, showSpinner );

                    }
    

                
            createSessionForInstallment(
                userIdentifier:string,
                subscriptionIdentifier:string,showSpinner = true): Promise<string> {
                        return CommonServices.defaultGet<string>(apiurl + 'api/Stripe/CreateSessionForInstallment',{ userIdentifier, subscriptionIdentifier }, showSpinner);

                    }
    }

export let StripeClient = new _StripeClient();

class _SurveyAnswersClient {

    

                
            getAll(showSpinner = true): Promise<OM.SurveyAnswers[]> {
                        return CommonServices.defaultGet<OM.SurveyAnswers[]>(apiurl + 'api/SurveyAnswers/GetAll',{  }, showSpinner);

                    }
    

                
            getById(
                identifier:string,showSpinner = true): Promise<OM.SurveyAnswers> {
                        return CommonServices.defaultGet<OM.SurveyAnswers>(apiurl + 'api/SurveyAnswers/GetById',{ identifier }, showSpinner);

                    }
    

                
            deleteById(
                identifier:string,showSpinner = true): Promise<void> {
                        return CommonServices.defaultGet<void>(apiurl + 'api/SurveyAnswers/DeleteById',{ identifier }, showSpinner);

                    }
    

                
            save(
                item:OM.SurveyAnswers,showSpinner = true): Promise<string> {
                        return CommonServices.defaultPost<string>(apiurl + 'api/SurveyAnswers/Save', item,{}, showSpinner );

                    }
    

                
            getAnswersOfCustomer(
                customerIdentifier:string,showSpinner = true): Promise<OM.SurveyAnswers[]> {
                        return CommonServices.defaultGet<OM.SurveyAnswers[]>(apiurl + 'api/SurveyAnswers/GetAnswersOfCustomer',{ customerIdentifier }, showSpinner);

                    }
    

                
            getAssessmentAnswersOfCustomer(
                customerIdentifier:string,
                professionIdentifier:string,
                doctorIdentifier:string,showSpinner = true): Promise<OM.SurveyAnswers[]> {
                        return CommonServices.defaultGet<OM.SurveyAnswers[]>(apiurl + 'api/SurveyAnswers/GetAssessmentAnswersOfCustomer',{ customerIdentifier, professionIdentifier, doctorIdentifier }, showSpinner);

                    }
    

                
            getInternalAnswersOfCustomer(
                customerIdentifier:string,
                professionIdentifier:string,
                doctorIdentifier:string,showSpinner = true): Promise<OM.SurveyAnswers[]> {
                        return CommonServices.defaultGet<OM.SurveyAnswers[]>(apiurl + 'api/SurveyAnswers/GetInternalAnswersOfCustomer',{ customerIdentifier, professionIdentifier, doctorIdentifier }, showSpinner);

                    }
    

                
            saveRisposte(
                item:OM.SurveyAnswers,showSpinner = true): Promise<string> {
                        return CommonServices.defaultPost<string>(apiurl + 'api/SurveyAnswers/SaveRisposte', item,{}, showSpinner );

                    }
    }

export let SurveyAnswersClient = new _SurveyAnswersClient();

class _SurveyClient {

    

                
            getAll(showSpinner = true): Promise<OM.Survey[]> {
                        return CommonServices.defaultGet<OM.Survey[]>(apiurl + 'api/Survey/GetAll',{  }, showSpinner);

                    }
    

                
            getById(
                identifier:string,showSpinner = true): Promise<OM.Survey> {
                        return CommonServices.defaultGet<OM.Survey>(apiurl + 'api/Survey/GetById',{ identifier }, showSpinner);

                    }
    

                
            deleteById(
                identifier:string,showSpinner = true): Promise<void> {
                        return CommonServices.defaultGet<void>(apiurl + 'api/Survey/DeleteById',{ identifier }, showSpinner);

                    }
    

                
            duplicate(
                identifier:string,showSpinner = true): Promise<void> {
                        return CommonServices.defaultGet<void>(apiurl + 'api/Survey/Duplicate',{ identifier }, showSpinner);

                    }
    

                
            save(
                item:OM.Survey,showSpinner = true): Promise<string> {
                        return CommonServices.defaultPost<string>(apiurl + 'api/Survey/Save', item,{}, showSpinner );

                    }
    

                
            getActiveAssessment(
                professionIdentifier:string,
                doctorIdentifier:string,showSpinner = true): Promise<OM.Survey> {
                        return CommonServices.defaultGet<OM.Survey>(apiurl + 'api/Survey/GetActiveAssessment',{ professionIdentifier, doctorIdentifier }, showSpinner);

                    }
    

                
            getActiveInternal(
                professionIdentifier:string,
                doctorIdentifier:string,showSpinner = true): Promise<OM.Survey> {
                        return CommonServices.defaultGet<OM.Survey>(apiurl + 'api/Survey/GetActiveInternal',{ professionIdentifier, doctorIdentifier }, showSpinner);

                    }
    

                
            getActivesByCustomerIdentifier(
                customerIdentifier:string,showSpinner = true): Promise<OM.SurveyListVm[]> {
                        return CommonServices.defaultGet<OM.SurveyListVm[]>(apiurl + 'api/Survey/GetActivesByCustomerIdentifier',{ customerIdentifier }, showSpinner);

                    }
    }

export let SurveyClient = new _SurveyClient();

class _UserPaymentRequestClient {

    

                
            downloadUserPaymentRequestReceipt(
                userPaymentRequestIdentifier:string,showSpinner = true): Promise<OM.NameIdentifier> {
                        return CommonServices.defaultGet<OM.NameIdentifier>(apiurl + 'api/UserPaymentRequest/DownloadUserPaymentRequestReceipt',{ userPaymentRequestIdentifier }, showSpinner);

                    }
    

                
            getAll(showSpinner = true): Promise<OM.UserPaymentRequest[]> {
                        return CommonServices.defaultGet<OM.UserPaymentRequest[]>(apiurl + 'api/UserPaymentRequest/GetAll',{  }, showSpinner);

                    }
    

                
            getByUserIdentifier(
                userIdentifier:string,showSpinner = true): Promise<OM.UserPaymentRequest[]> {
                        return CommonServices.defaultGet<OM.UserPaymentRequest[]>(apiurl + 'api/UserPaymentRequest/GetByUserIdentifier',{ userIdentifier }, showSpinner);

                    }
    

                
            generaRitenutaAcconto(
                paymentRequestIdentifier:string,showSpinner = true): Promise<OM.NameIdentifier> {
                        return CommonServices.defaultGet<OM.NameIdentifier>(apiurl + 'api/UserPaymentRequest/GeneraRitenutaAcconto',{ paymentRequestIdentifier }, showSpinner);

                    }
    

                
            save(
                item:OM.BaseWalletTransaction,showSpinner = true): Promise<void> {
                        return CommonServices.defaultPost<void>(apiurl + 'api/UserPaymentRequest/Save', item,{}, showSpinner );

                    }
    

                
            confirmUserPaymentRequest(
                vm:OM.ConfirmUserPaymentRequestVm,showSpinner = true): Promise<void> {
                        return CommonServices.defaultPost<void>(apiurl + 'api/UserPaymentRequest/ConfirmUserPaymentRequest', vm,{}, showSpinner );

                    }
    

                
            annullaRichiestaPagamento(
                requestIdentifier:string,showSpinner = true): Promise<void> {
                        return CommonServices.defaultGet<void>(apiurl + 'api/UserPaymentRequest/AnnullaRichiestaPagamento',{ requestIdentifier }, showSpinner);

                    }
    

                
            getPendingRequest(
                userIdentifier:string,showSpinner = true): Promise<OM.UserPaymentRequest> {
                        return CommonServices.defaultGet<OM.UserPaymentRequest>(apiurl + 'api/UserPaymentRequest/GetPendingRequest',{ userIdentifier }, showSpinner);

                    }
    }

export let UserPaymentRequestClient = new _UserPaymentRequestClient();

class _ClubVacationVoucherClient {

    

                
            getAll(
                vm:OM.ClubVacationVoucherListFilterVm,showSpinner = true): Promise<OM.TablePagedResultOfClubVacationVoucher> {
                        return CommonServices.defaultPost<OM.TablePagedResultOfClubVacationVoucher>(apiurl + 'api/ClubVacationVoucher/GetAll', vm,{}, showSpinner );

                    }
    

                
            getByUser(
                userIdentifier:string,showSpinner = true): Promise<OM.ClubVacationVoucher[]> {
                        return CommonServices.defaultGet<OM.ClubVacationVoucher[]>(apiurl + 'api/ClubVacationVoucher/GetByUser',{ userIdentifier }, showSpinner);

                    }
    

                
            getBySubscription(
                subscriptionIdentifier:string,showSpinner = true): Promise<OM.ClubVacationVoucher[]> {
                        return CommonServices.defaultGet<OM.ClubVacationVoucher[]>(apiurl + 'api/ClubVacationVoucher/GetBySubscription',{ subscriptionIdentifier }, showSpinner);

                    }
    

                
            deleteById(
                identifier:string,showSpinner = true): Promise<OM.ClubVacationVoucher[]> {
                        return CommonServices.defaultGet<OM.ClubVacationVoucher[]>(apiurl + 'api/ClubVacationVoucher/DeleteById',{ identifier }, showSpinner);

                    }
    

                
            save(
                item:OM.ClubVacationVoucher,showSpinner = true): Promise<string> {
                        return CommonServices.defaultPost<string>(apiurl + 'api/ClubVacationVoucher/Save', item,{}, showSpinner );

                    }
    

                
            removeCommento(
                itemIdentifier:string,
                commentIdentifier:string,showSpinner = true): Promise<void> {
                        return CommonServices.defaultGet<void>(apiurl + 'api/ClubVacationVoucher/RemoveCommento',{ itemIdentifier, commentIdentifier }, showSpinner);

                    }
    }

export let ClubVacationVoucherClient = new _ClubVacationVoucherClient();

class _ParkedVacationClient {

    

                
            getAll(
                vm:OM.ParkedVacationListFilterVm,showSpinner = true): Promise<OM.TablePagedResultOfParkedVacation> {
                        return CommonServices.defaultPost<OM.TablePagedResultOfParkedVacation>(apiurl + 'api/ParkedVacation/GetAll', vm,{}, showSpinner );

                    }
    

                
            parkVacation(
                bookingVoucherIdentifier:string,showSpinner = true): Promise<OM.ParkedVacation> {
                        return CommonServices.defaultGet<OM.ParkedVacation>(apiurl + 'api/ParkedVacation/ParkVacation',{ bookingVoucherIdentifier }, showSpinner);

                    }
    

                
            getById(
                identifier:string,showSpinner = true): Promise<OM.ParkedVacation> {
                        return CommonServices.defaultGet<OM.ParkedVacation>(apiurl + 'api/ParkedVacation/GetById',{ identifier }, showSpinner);

                    }
    

                
            getByUser(
                userIdentifier:string,showSpinner = true): Promise<OM.ParkedVacation[]> {
                        return CommonServices.defaultGet<OM.ParkedVacation[]>(apiurl + 'api/ParkedVacation/GetByUser',{ userIdentifier }, showSpinner);

                    }
    

                
            save(
                item:OM.ParkedVacation,showSpinner = true): Promise<string> {
                        return CommonServices.defaultPost<string>(apiurl + 'api/ParkedVacation/Save', item,{}, showSpinner );

                    }
    

                
            deleteById(
                identifier:string,showSpinner = true): Promise<void> {
                        return CommonServices.defaultGet<void>(apiurl + 'api/ParkedVacation/DeleteById',{ identifier }, showSpinner);

                    }
    }

export let ParkedVacationClient = new _ParkedVacationClient();

class _VideoReviewClient {

    

                
            getAll(showSpinner = true): Promise<OM.VideoReview[]> {
                        return CommonServices.defaultGet<OM.VideoReview[]>(apiurl + 'api/VideoReview/GetAll',{  }, showSpinner);

                    }
    

                
            getByUserIdentifier(
                userIdentifier:string,showSpinner = true): Promise<OM.VideoReview[]> {
                        return CommonServices.defaultGet<OM.VideoReview[]>(apiurl + 'api/VideoReview/GetByUserIdentifier',{ userIdentifier }, showSpinner);

                    }
    

                
            getAllByVillage(
                villageIdentifier:string,showSpinner = true): Promise<OM.VideoReview[]> {
                        return CommonServices.defaultGet<OM.VideoReview[]>(apiurl + 'api/VideoReview/GetAllByVillage',{ villageIdentifier }, showSpinner);

                    }
    

                
            checkHasDoneReview(
                userIdentifier:string,showSpinner = true): Promise<boolean> {
                        return CommonServices.defaultGet<boolean>(apiurl + 'api/VideoReview/CheckHasDoneReview',{ userIdentifier }, showSpinner);

                    }
    

                
            moveToGallery(
                vm:OM.MoveVideoReviewToGalleryVm,showSpinner = true): Promise<OM.VillageGlobalGalleryItem> {
                        return CommonServices.defaultGet<OM.VillageGlobalGalleryItem>(apiurl + 'api/VideoReview/MoveToGallery',{ vm }, showSpinner);

                    }
    

                
            deleteById(
                identifier:string,showSpinner = true): Promise<void> {
                        return CommonServices.defaultGet<void>(apiurl + 'api/VideoReview/DeleteById',{ identifier }, showSpinner);

                    }
    

                
            approveVideoReview(
                identifier:string,
                approve:boolean,showSpinner = true): Promise<void> {
                        return CommonServices.defaultGet<void>(apiurl + 'api/VideoReview/ApproveVideoReview',{ identifier, approve }, showSpinner);

                    }
    

                
            isVideoReviewApproved(
                userIdentifier:string,showSpinner = true): Promise<boolean> {
                        return CommonServices.defaultGet<boolean>(apiurl + 'api/VideoReview/IsVideoReviewApproved',{ userIdentifier }, showSpinner);

                    }
    }

export let VideoReviewClient = new _VideoReviewClient();

class _VillageEventClient {

    

                
            getByVillage(
                villageIdentifier:string,
                eventGroup:string,
                date:string,showSpinner = true): Promise<OM.VillageEvent[]> {
                        return CommonServices.defaultGet<OM.VillageEvent[]>(apiurl + 'api/VillageEvent/GetByVillage',{ villageIdentifier, eventGroup, date }, showSpinner);

                    }
    

                
            getAll(showSpinner = true): Promise<OM.VillageEvent[]> {
                        return CommonServices.defaultGet<OM.VillageEvent[]>(apiurl + 'api/VillageEvent/GetAll',{  }, showSpinner);

                    }
    

                
            getAllByVillage(
                villageIdentifier:string,showSpinner = true): Promise<OM.VillageEvent[]> {
                        return CommonServices.defaultGet<OM.VillageEvent[]>(apiurl + 'api/VillageEvent/GetAllByVillage',{ villageIdentifier }, showSpinner);

                    }
    

                
            getById(
                identifier:string,showSpinner = true): Promise<OM.VillageEvent> {
                        return CommonServices.defaultGet<OM.VillageEvent>(apiurl + 'api/VillageEvent/GetById',{ identifier }, showSpinner);

                    }
    

                
            deleteById(
                identifier:string,showSpinner = true): Promise<void> {
                        return CommonServices.defaultGet<void>(apiurl + 'api/VillageEvent/DeleteById',{ identifier }, showSpinner);

                    }
    

                
            duplicate(
                identifier:string,showSpinner = true): Promise<void> {
                        return CommonServices.defaultGet<void>(apiurl + 'api/VillageEvent/Duplicate',{ identifier }, showSpinner);

                    }
    

                
            save(
                item:OM.VillageEvent,showSpinner = true): Promise<string> {
                        return CommonServices.defaultPost<string>(apiurl + 'api/VillageEvent/Save', item,{}, showSpinner );

                    }
    }

export let VillageEventClient = new _VillageEventClient();

class _VillageTripBookingClient {

    

                
            save(
                item:OM.VillageTripBooking,showSpinner = true): Promise<string> {
                        return CommonServices.defaultPost<string>(apiurl + 'api/VillageTripBooking/Save', item,{}, showSpinner );

                    }
    

                
            book(
                vm:OM.BookExcursionVm,showSpinner = true): Promise<OM.VillageTripBooking> {
                        return CommonServices.defaultPost<OM.VillageTripBooking>(apiurl + 'api/VillageTripBooking/Book', vm,{}, showSpinner );

                    }
    

                
            getAll(
                showCanceled:boolean,showSpinner = true): Promise<OM.VillageTripBooking[]> {
                        return CommonServices.defaultGet<OM.VillageTripBooking[]>(apiurl + 'api/VillageTripBooking/GetAll',{ showCanceled }, showSpinner);

                    }
    

                
            getByUserIdentifier(
                userIdentifier:string,showSpinner = true): Promise<OM.VillageTripBooking[]> {
                        return CommonServices.defaultGet<OM.VillageTripBooking[]>(apiurl + 'api/VillageTripBooking/GetByUserIdentifier',{ userIdentifier }, showSpinner);

                    }
    

                
            getAllByVillage(
                showCanceled:boolean,
                villageIdentifier:string,showSpinner = true): Promise<OM.VillageTripBooking[]> {
                        return CommonServices.defaultGet<OM.VillageTripBooking[]>(apiurl + 'api/VillageTripBooking/GetAllByVillage',{ showCanceled, villageIdentifier }, showSpinner);

                    }
    

                
            confirmBooking(
                vm:OM.VillageTripBookingActionVm,showSpinner = true): Promise<OM.VillageTripBooking> {
                        return CommonServices.defaultPost<OM.VillageTripBooking>(apiurl + 'api/VillageTripBooking/ConfirmBooking', vm,{}, showSpinner );

                    }
    

                
            denyBooking(
                vm:OM.VillageTripBookingActionVm,showSpinner = true): Promise<OM.VillageTripBooking> {
                        return CommonServices.defaultPost<OM.VillageTripBooking>(apiurl + 'api/VillageTripBooking/DenyBooking', vm,{}, showSpinner );

                    }
    

                
            cancelBooking(
                vm:OM.VillageTripBookingActionVm,showSpinner = true): Promise<OM.VillageTripBooking> {
                        return CommonServices.defaultPost<OM.VillageTripBooking>(apiurl + 'api/VillageTripBooking/CancelBooking', vm,{}, showSpinner );

                    }
    

                
            getPendingByUser(
                userIdentifier:string,
                tripIdentifier:string,showSpinner = true): Promise<OM.VillageTripBooking> {
                        return CommonServices.defaultGet<OM.VillageTripBooking>(apiurl + 'api/VillageTripBooking/GetPendingByUser',{ userIdentifier, tripIdentifier }, showSpinner);

                    }
    }

export let VillageTripBookingClient = new _VillageTripBookingClient();

class _VillageTripClient {

    

                
            getByVillage(
                villageIdentifier:string,showSpinner = true): Promise<OM.VillageTrip[]> {
                        return CommonServices.defaultGet<OM.VillageTrip[]>(apiurl + 'api/VillageTrip/GetByVillage',{ villageIdentifier }, showSpinner);

                    }
    

                
            getAllByVillage(
                villageIdentifier:string,showSpinner = true): Promise<OM.VillageTrip[]> {
                        return CommonServices.defaultGet<OM.VillageTrip[]>(apiurl + 'api/VillageTrip/GetAllByVillage',{ villageIdentifier }, showSpinner);

                    }
    

                
            getUpcomingBookDays(
                villageTripIdentifier:string,showSpinner = true): Promise<string[]> {
                        return CommonServices.defaultGet<string[]>(apiurl + 'api/VillageTrip/GetUpcomingBookDays',{ villageTripIdentifier }, showSpinner);

                    }
    

                
            getById(
                identifier:string,showSpinner = true): Promise<OM.VillageTrip> {
                        return CommonServices.defaultGet<OM.VillageTrip>(apiurl + 'api/VillageTrip/GetById',{ identifier }, showSpinner);

                    }
    

                
            deleteById(
                identifier:string,showSpinner = true): Promise<void> {
                        return CommonServices.defaultGet<void>(apiurl + 'api/VillageTrip/DeleteById',{ identifier }, showSpinner);

                    }
    

                
            duplicate(
                identifier:string,showSpinner = true): Promise<void> {
                        return CommonServices.defaultGet<void>(apiurl + 'api/VillageTrip/Duplicate',{ identifier }, showSpinner);

                    }
    

                
            save(
                item:OM.VillageTrip,showSpinner = true): Promise<string> {
                        return CommonServices.defaultPost<string>(apiurl + 'api/VillageTrip/Save', item,{}, showSpinner );

                    }
    

                
            addGalleryImage(
                vm:OM.AddAttachmentVm,showSpinner = true): Promise<void> {
                        return CommonServices.defaultPost<void>(apiurl + 'api/VillageTrip/AddGalleryImage', vm,{}, showSpinner );

                    }
    

                
            removeGalleryImage(
                identifier:string,
                index:number,showSpinner = true): Promise<void> {
                        return CommonServices.defaultGet<void>(apiurl + 'api/VillageTrip/RemoveGalleryImage',{ identifier, index }, showSpinner);

                    }
    }

export let VillageTripClient = new _VillageTripClient();

class _WallesterKeysConfigClient {

    

                
            getByProject(
                projectIdentifier:string,showSpinner = true): Promise<OM.WallesterKeysConfig> {
                        return CommonServices.defaultGet<OM.WallesterKeysConfig>(apiurl + 'api/WallesterKeysConfig/GetByProject',{ projectIdentifier }, showSpinner);

                    }
    

                
            setApiKey(
                projectIdentifier:string,
                apiKey:string,showSpinner = true): Promise<void> {
                        return CommonServices.defaultGet<void>(apiurl + 'api/WallesterKeysConfig/SetApiKey',{ projectIdentifier, apiKey }, showSpinner);

                    }
    }

export let WallesterKeysConfigClient = new _WallesterKeysConfigClient();

class _WalletTransactionClient {

    

                
            save(
                item:OM.BaseWalletTransaction,showSpinner = true): Promise<void> {
                        return CommonServices.defaultPost<void>(apiurl + 'api/WalletTransaction/Save', item,{}, showSpinner );

                    }
    

                
            makeTrasferimentoSaldo(
                vm:OM.CreateMoneyTransferVm,showSpinner = true): Promise<void> {
                        return CommonServices.defaultPost<void>(apiurl + 'api/WalletTransaction/MakeTrasferimentoSaldo', vm,{}, showSpinner );

                    }
    

                
            makeManualBonus(
                vm:OM.CreateManualBonusVm,showSpinner = true): Promise<void> {
                        return CommonServices.defaultPost<void>(apiurl + 'api/WalletTransaction/MakeManualBonus', vm,{}, showSpinner );

                    }
    

                
            getWalletTransactions(
                vm:OM.WalletTransactionsListFilterVm,showSpinner = true): Promise<OM.TablePagedResultOfBaseWalletTransaction> {
                        return CommonServices.defaultPost<OM.TablePagedResultOfBaseWalletTransaction>(apiurl + 'api/WalletTransaction/GetWalletTransactions', vm,{}, showSpinner );

                    }
    

                
            removeTransaction(
                identifier:string,showSpinner = true): Promise<void> {
                        return CommonServices.defaultGet<void>(apiurl + 'api/WalletTransaction/RemoveTransaction',{ identifier }, showSpinner);

                    }
    }

export let WalletTransactionClient = new _WalletTransactionClient();

class _WordpressPostClient {

    

                
            getPosts(
                page:number,showSpinner = true): Promise<OM.WordpressPostVm[]> {
                        return CommonServices.defaultGet<OM.WordpressPostVm[]>(apiurl + 'api/WordpressPost/GetPosts',{ page }, showSpinner);

                    }
    

                
            getPostDetail(
                postId:number,showSpinner = true): Promise<OM.WordpressPostVm> {
                        return CommonServices.defaultGet<OM.WordpressPostVm>(apiurl + 'api/WordpressPost/GetPostDetail',{ postId }, showSpinner);

                    }
    }

export let WordpressPostClient = new _WordpressPostClient();

class _VillageConfigClient {

    

                
            getAvailable(showSpinner = true): Promise<OM.VillageConfig[]> {
                        return CommonServices.defaultGet<OM.VillageConfig[]>(apiurl + 'api/VillageConfig/GetAvailable',{  }, showSpinner);

                    }
    

                
            getNameIdentifiers(showSpinner = true): Promise<OM.NameIdentifier[]> {
                        return CommonServices.defaultGet<OM.NameIdentifier[]>(apiurl + 'api/VillageConfig/GetNameIdentifiers',{  }, showSpinner);

                    }
    

                
            getVillageMenuVm(showSpinner = true): Promise<OM.VillageMenuVm[]> {
                        return CommonServices.defaultGet<OM.VillageMenuVm[]>(apiurl + 'api/VillageConfig/GetVillageMenuVm',{  }, showSpinner);

                    }
    

                
            getAll(showSpinner = true): Promise<OM.VillageConfig[]> {
                        return CommonServices.defaultGet<OM.VillageConfig[]>(apiurl + 'api/VillageConfig/GetAll',{  }, showSpinner);

                    }
    

                
            getById(
                identifier:string,showSpinner = true): Promise<OM.VillageConfig> {
                        return CommonServices.defaultGet<OM.VillageConfig>(apiurl + 'api/VillageConfig/GetById',{ identifier }, showSpinner);

                    }
    

                
            deleteById(
                identifier:string,showSpinner = true): Promise<void> {
                        return CommonServices.defaultGet<void>(apiurl + 'api/VillageConfig/DeleteById',{ identifier }, showSpinner);

                    }
    

                
            duplicate(
                identifier:string,showSpinner = true): Promise<void> {
                        return CommonServices.defaultGet<void>(apiurl + 'api/VillageConfig/Duplicate',{ identifier }, showSpinner);

                    }
    

                
            save(
                item:OM.VillageConfig,showSpinner = true): Promise<string> {
                        return CommonServices.defaultPost<string>(apiurl + 'api/VillageConfig/Save', item,{}, showSpinner );

                    }
    

                
            addGalleryImage(
                vm:OM.AddAttachmentVm,showSpinner = true): Promise<void> {
                        return CommonServices.defaultPost<void>(apiurl + 'api/VillageConfig/AddGalleryImage', vm,{}, showSpinner );

                    }
    

                
            removeGalleryImage(
                identifier:string,
                index:number,showSpinner = true): Promise<void> {
                        return CommonServices.defaultGet<void>(apiurl + 'api/VillageConfig/RemoveGalleryImage',{ identifier, index }, showSpinner);

                    }
    

                
            getVillageByCoords(
                lat:number,
                lng:number,showSpinner = true): Promise<OM.VillageConfig> {
                        return CommonServices.defaultGet<OM.VillageConfig>(apiurl + 'api/VillageConfig/GetVillageByCoords',{ lat, lng }, showSpinner);

                    }
    }

export let VillageConfigClient = new _VillageConfigClient();

class _VillageGlobalGalleryItemClient {

    

                
            getAll(showSpinner = true): Promise<OM.VillageGlobalGalleryItem[]> {
                        return CommonServices.defaultGet<OM.VillageGlobalGalleryItem[]>(apiurl + 'api/VillageGlobalGalleryItem/GetAll',{  }, showSpinner);

                    }
    

                
            getAllByVillage(
                villageIdentifier:string,showSpinner = true): Promise<OM.VillageGlobalGalleryItem[]> {
                        return CommonServices.defaultGet<OM.VillageGlobalGalleryItem[]>(apiurl + 'api/VillageGlobalGalleryItem/GetAllByVillage',{ villageIdentifier }, showSpinner);

                    }
    

                
            getById(
                identifier:string,showSpinner = true): Promise<OM.VillageGlobalGalleryItem> {
                        return CommonServices.defaultGet<OM.VillageGlobalGalleryItem>(apiurl + 'api/VillageGlobalGalleryItem/GetById',{ identifier }, showSpinner);

                    }
    

                
            getByVillage(
                villageIdentifier:string,
                fromDate:string,
                toDate:string,
                skip:number,
                take:number,showSpinner = true): Promise<OM.VillageGlobalGalleryItem[]> {
                        return CommonServices.defaultGet<OM.VillageGlobalGalleryItem[]>(apiurl + 'api/VillageGlobalGalleryItem/GetByVillage',{ villageIdentifier, fromDate, toDate, skip, take }, showSpinner);

                    }
    

                
            deleteById(
                identifier:string,showSpinner = true): Promise<void> {
                        return CommonServices.defaultGet<void>(apiurl + 'api/VillageGlobalGalleryItem/DeleteById',{ identifier }, showSpinner);

                    }
    

                
            purchaseGalleryItem(
                userIdentifier:string,
                globalGalleryItemIdentifier:string,showSpinner = true): Promise<void> {
                        return CommonServices.defaultGet<void>(apiurl + 'api/VillageGlobalGalleryItem/PurchaseGalleryItem',{ userIdentifier, globalGalleryItemIdentifier }, showSpinner);

                    }
    

                
            getBoughtByUser(
                userIdentifier:string,showSpinner = true): Promise<OM.VillageGlobalGalleryItem[]> {
                        return CommonServices.defaultGet<OM.VillageGlobalGalleryItem[]>(apiurl + 'api/VillageGlobalGalleryItem/GetBoughtByUser',{ userIdentifier }, showSpinner);

                    }
    

                
            save(
                item:OM.VillageGlobalGalleryItem,showSpinner = true): Promise<string> {
                        return CommonServices.defaultPost<string>(apiurl + 'api/VillageGlobalGalleryItem/Save', item,{}, showSpinner );

                    }
    }

export let VillageGlobalGalleryItemClient = new _VillageGlobalGalleryItemClient();

class _VillageScratchAndWinClient {

    

                
            getAll(
                villageIdentifier:string,showSpinner = true): Promise<OM.VillageScratchAndWin[]> {
                        return CommonServices.defaultGet<OM.VillageScratchAndWin[]>(apiurl + 'api/VillageScratchAndWin/GetAll',{ villageIdentifier }, showSpinner);

                    }
    

                
            getPlays(
                villageIdentifier:string,showSpinner = true): Promise<OM.VillageScratchAndWinPlay[]> {
                        return CommonServices.defaultGet<OM.VillageScratchAndWinPlay[]>(apiurl + 'api/VillageScratchAndWin/GetPlays',{ villageIdentifier }, showSpinner);

                    }
    

                
            getById(
                identifier:string,showSpinner = true): Promise<OM.VillageScratchAndWin> {
                        return CommonServices.defaultGet<OM.VillageScratchAndWin>(apiurl + 'api/VillageScratchAndWin/GetById',{ identifier }, showSpinner);

                    }
    

                
            getWinnableItemsList(
                villageIdentifier:string,showSpinner = true): Promise<OM.LocalizedValue[]> {
                        return CommonServices.defaultGet<OM.LocalizedValue[]>(apiurl + 'api/VillageScratchAndWin/GetWinnableItemsList',{ villageIdentifier }, showSpinner);

                    }
    

                
            deleteById(
                identifier:string,showSpinner = true): Promise<void> {
                        return CommonServices.defaultGet<void>(apiurl + 'api/VillageScratchAndWin/DeleteById',{ identifier }, showSpinner);

                    }
    

                
            duplicate(
                identifier:string,showSpinner = true): Promise<void> {
                        return CommonServices.defaultGet<void>(apiurl + 'api/VillageScratchAndWin/Duplicate',{ identifier }, showSpinner);

                    }
    

                
            getVillageScratchAndWinBackground(
                villageIdentifier:string,showSpinner = true): Promise<OM.Attachment> {
                        return CommonServices.defaultGet<OM.Attachment>(apiurl + 'api/VillageScratchAndWin/GetVillageScratchAndWinBackground',{ villageIdentifier }, showSpinner);

                    }
    

                
            getWinnableItem(
                villageIdentifier:string,
                userIdentifier:string,showSpinner = true): Promise<OM.VillageScratchAndWinPlay> {
                        return CommonServices.defaultGet<OM.VillageScratchAndWinPlay>(apiurl + 'api/VillageScratchAndWin/GetWinnableItem',{ villageIdentifier, userIdentifier }, showSpinner);

                    }
    

                
            getUserPlay(
                userIdentifier:string,
                villageIdentifier:string,showSpinner = true): Promise<OM.VillageScratchAndWinPlay> {
                        return CommonServices.defaultGet<OM.VillageScratchAndWinPlay>(apiurl + 'api/VillageScratchAndWin/GetUserPlay',{ userIdentifier, villageIdentifier }, showSpinner);

                    }
    

                
            getByUserIdentifier(
                userIdentifier:string,showSpinner = true): Promise<OM.VillageScratchAndWinPlay[]> {
                        return CommonServices.defaultGet<OM.VillageScratchAndWinPlay[]>(apiurl + 'api/VillageScratchAndWin/GetByUserIdentifier',{ userIdentifier }, showSpinner);

                    }
    

                
            setRedeemedOn(
                itemIdentifier:string,showSpinner = true): Promise<void> {
                        return CommonServices.defaultGet<void>(apiurl + 'api/VillageScratchAndWin/SetRedeemedOn',{ itemIdentifier }, showSpinner);

                    }
    

                
            scratchPlayNow(
                playIdentifier:string,showSpinner = true): Promise<string> {
                        return CommonServices.defaultGet<string>(apiurl + 'api/VillageScratchAndWin/ScratchPlayNow',{ playIdentifier }, showSpinner);

                    }
    

                
            save(
                item:OM.VillageScratchAndWin,showSpinner = true): Promise<string> {
                        return CommonServices.defaultPost<string>(apiurl + 'api/VillageScratchAndWin/Save', item,{}, showSpinner );

                    }
    }

export let VillageScratchAndWinClient = new _VillageScratchAndWinClient();

class _ClubVacationBookingClient {

    

                
            getAll(
                vm:OM.ClubVacationBookingListFilterVm,showSpinner = true): Promise<OM.TablePagedResultOfClubVacationBooking> {
                        return CommonServices.defaultPost<OM.TablePagedResultOfClubVacationBooking>(apiurl + 'api/ClubVacationBooking/GetAll', vm,{}, showSpinner );

                    }
    

                
            exportExcel(
                vm:OM.ClubVacationBookingListFilterVm,showSpinner = true): Promise<OM.NameIdentifier> {
                        return CommonServices.defaultPost<OM.NameIdentifier>(apiurl + 'api/ClubVacationBooking/ExportExcel', vm,{}, showSpinner );

                    }
    

                
            newVacationBooking(
                vm:OM.NewVacationBookingVm,showSpinner = true): Promise<OM.ClubVacationBooking> {
                        return CommonServices.defaultPost<OM.ClubVacationBooking>(apiurl + 'api/ClubVacationBooking/NewVacationBooking', vm,{}, showSpinner );

                    }
    

                
            getRemainingWeeks(
                userIdentifier:string,showSpinner = true): Promise<OM.RemainingBookingWeeksVm> {
                        return CommonServices.defaultGet<OM.RemainingBookingWeeksVm>(apiurl + 'api/ClubVacationBooking/GetRemainingWeeks',{ userIdentifier }, showSpinner);

                    }
    

                
            getById(
                identifier:string,showSpinner = true): Promise<OM.ClubVacationBooking> {
                        return CommonServices.defaultGet<OM.ClubVacationBooking>(apiurl + 'api/ClubVacationBooking/GetById',{ identifier }, showSpinner);

                    }
    

                
            getAvailableDates(
                villageIdentifier:string,
                from:string,
                to:string,showSpinner = true): Promise<string[]> {
                        return CommonServices.defaultGet<string[]>(apiurl + 'api/ClubVacationBooking/GetAvailableDates',{ villageIdentifier, from, to }, showSpinner);

                    }
    

                
            getByUser(
                userIdentifier:string,showSpinner = true): Promise<OM.ClubVacationBookingVm[]> {
                        return CommonServices.defaultGet<OM.ClubVacationBookingVm[]>(apiurl + 'api/ClubVacationBooking/GetByUser',{ userIdentifier }, showSpinner);

                    }
    

                
            save(
                item:OM.ClubVacationBooking,showSpinner = true): Promise<string> {
                        return CommonServices.defaultPost<string>(apiurl + 'api/ClubVacationBooking/Save', item,{}, showSpinner );

                    }
    

                
            cancelClubVacationBooking(
                identifier:string,showSpinner = true): Promise<void> {
                        return CommonServices.defaultGet<void>(apiurl + 'api/ClubVacationBooking/CancelClubVacationBooking',{ identifier }, showSpinner);

                    }
    

                
            deleteById(
                identifier:string,showSpinner = true): Promise<void> {
                        return CommonServices.defaultGet<void>(apiurl + 'api/ClubVacationBooking/DeleteById',{ identifier }, showSpinner);

                    }
    

                
            sendClubVacationBookingConfirmed(
                vm:OM.ClubVacationBookingActionVm,showSpinner = true): Promise<OM.VillageTripBooking> {
                        return CommonServices.defaultPost<OM.VillageTripBooking>(apiurl + 'api/ClubVacationBooking/SendClubVacationBookingConfirmed', vm,{}, showSpinner );

                    }
    

                
            sendClubVacationBookingCanceled(
                vm:OM.ClubVacationBookingActionVm,showSpinner = true): Promise<OM.VillageTripBooking> {
                        return CommonServices.defaultPost<OM.VillageTripBooking>(apiurl + 'api/ClubVacationBooking/SendClubVacationBookingCanceled', vm,{}, showSpinner );

                    }
    }

export let ClubVacationBookingClient = new _ClubVacationBookingClient();

class _BaseProductClient {

    

                
            getAll(showSpinner = true): Promise<OM.BaseProduct[]> {
                        return CommonServices.defaultGet<OM.BaseProduct[]>(apiurl + 'api/BaseProduct/GetAll',{  }, showSpinner);

                    }
    

                
            getAllNameIdentifier(showSpinner = true): Promise<OM.NameIdentifier[]> {
                        return CommonServices.defaultGet<OM.NameIdentifier[]>(apiurl + 'api/BaseProduct/GetAllNameIdentifier',{  }, showSpinner);

                    }
    

                
            getById(
                identifier:string,showSpinner = true): Promise<OM.BaseProduct> {
                        return CommonServices.defaultGet<OM.BaseProduct>(apiurl + 'api/BaseProduct/GetById',{ identifier }, showSpinner);

                    }
    

                
            save(
                item:OM.BaseProduct,showSpinner = true): Promise<string> {
                        return CommonServices.defaultPost<string>(apiurl + 'api/BaseProduct/Save', item,{}, showSpinner );

                    }
    

                
            getProductTypes(showSpinner = true): Promise<string[]> {
                        return CommonServices.defaultGet<string[]>(apiurl + 'api/BaseProduct/GetProductTypes',{  }, showSpinner);

                    }
    

                
            getAvailableSubscriptionTiers(showSpinner = true): Promise<number[]> {
                        return CommonServices.defaultGet<number[]>(apiurl + 'api/BaseProduct/GetAvailableSubscriptionTiers',{  }, showSpinner);

                    }
    

                
            duplicaProdotto(
                identifier:string,showSpinner = true): Promise<void> {
                        return CommonServices.defaultGet<void>(apiurl + 'api/BaseProduct/DuplicaProdotto',{ identifier }, showSpinner);

                    }
    

                
            delete(
                identifier:string,showSpinner = true): Promise<void> {
                        return CommonServices.defaultGet<void>(apiurl + 'api/BaseProduct/Delete',{ identifier }, showSpinner);

                    }
    }

export let BaseProductClient = new _BaseProductClient();

class _ShopCategoryClient {

    

                
            getAll(showSpinner = true): Promise<OM.ShopCategory[]> {
                        return CommonServices.defaultGet<OM.ShopCategory[]>(apiurl + 'api/ShopCategory/GetAll',{  }, showSpinner);

                    }
    

                
            getNameIdentifier(
                identifier:string,showSpinner = true): Promise<OM.LocalizedNameIdentifier> {
                        return CommonServices.defaultGet<OM.LocalizedNameIdentifier>(apiurl + 'api/ShopCategory/GetNameIdentifier',{ identifier }, showSpinner);

                    }
    

                
            getById(
                identifier:string,showSpinner = true): Promise<OM.ShopCategory> {
                        return CommonServices.defaultGet<OM.ShopCategory>(apiurl + 'api/ShopCategory/GetById',{ identifier }, showSpinner);

                    }
    

                
            getNameIdentifierList(showSpinner = true): Promise<OM.NameIdentifier[]> {
                        return CommonServices.defaultGet<OM.NameIdentifier[]>(apiurl + 'api/ShopCategory/GetNameIdentifierList',{  }, showSpinner);

                    }
    

                
            save(
                item:OM.ShopCategory,showSpinner = true): Promise<string> {
                        return CommonServices.defaultPost<string>(apiurl + 'api/ShopCategory/Save', item,{}, showSpinner );

                    }
    

                
            getUpsellCategoryIdentifier(showSpinner = true): Promise<string> {
                        return CommonServices.defaultGet<string>(apiurl + 'api/ShopCategory/GetUpsellCategoryIdentifier',{  }, showSpinner);

                    }
    

                
            getOfferteRiservateSociCategory(showSpinner = true): Promise<OM.ShopCategory> {
                        return CommonServices.defaultGet<OM.ShopCategory>(apiurl + 'api/ShopCategory/GetOfferteRiservateSociCategory',{  }, showSpinner);

                    }
    

                
            getEntryCategoryIdentifier(showSpinner = true): Promise<string> {
                        return CommonServices.defaultGet<string>(apiurl + 'api/ShopCategory/GetEntryCategoryIdentifier',{  }, showSpinner);

                    }
    

                
            delete(
                identifier:string,showSpinner = true): Promise<void> {
                        return CommonServices.defaultGet<void>(apiurl + 'api/ShopCategory/Delete',{ identifier }, showSpinner);

                    }
    

                
            getCategoriesForCliente(
                clienteIdentifier:string,showSpinner = true): Promise<OM.ShopCategory[]> {
                        return CommonServices.defaultGet<OM.ShopCategory[]>(apiurl + 'api/ShopCategory/GetCategoriesForCliente',{ clienteIdentifier }, showSpinner);

                    }
    }

export let ShopCategoryClient = new _ShopCategoryClient();

class _ShopOfferClient {

    

                
            getAll(showSpinner = true): Promise<OM.ShopOffer[]> {
                        return CommonServices.defaultGet<OM.ShopOffer[]>(apiurl + 'api/ShopOffer/GetAll',{  }, showSpinner);

                    }
    

                
            attivaOffertaFromBackend(
                clienteIdentifier:string,
                offertaIdentifier:string,showSpinner = true): Promise<void> {
                        return CommonServices.defaultGet<void>(apiurl + 'api/ShopOffer/AttivaOffertaFromBackend',{ clienteIdentifier, offertaIdentifier }, showSpinner);

                    }
    

                
            checkContainsSpedibili(
                offerIdentifier:string,showSpinner = true): Promise<boolean> {
                        return CommonServices.defaultGet<boolean>(apiurl + 'api/ShopOffer/CheckContainsSpedibili',{ offerIdentifier }, showSpinner);

                    }
    

                
            getById(
                identifier:string,showSpinner = true): Promise<OM.ShopOffer> {
                        return CommonServices.defaultGet<OM.ShopOffer>(apiurl + 'api/ShopOffer/GetById',{ identifier }, showSpinner);

                    }
    

                
            fullTextSearch(
                text:string,
                selectedCulture:string,showSpinner = true): Promise<OM.ShopFullTextSearchResultVm> {
                        return CommonServices.defaultGet<OM.ShopFullTextSearchResultVm>(apiurl + 'api/ShopOffer/FullTextSearch',{ text, selectedCulture }, showSpinner);

                    }
    

                
            getPopularOffers(showSpinner = true): Promise<OM.ShopOffer[]> {
                        return CommonServices.defaultGet<OM.ShopOffer[]>(apiurl + 'api/ShopOffer/GetPopularOffers',{  }, showSpinner);

                    }
    

                
            getByCategory(
                categoryIdentifier:string,showSpinner = true): Promise<OM.ShopOffer[]> {
                        return CommonServices.defaultGet<OM.ShopOffer[]>(apiurl + 'api/ShopOffer/GetByCategory',{ categoryIdentifier }, showSpinner);

                    }
    

                
            save(
                item:OM.ShopOffer,showSpinner = true): Promise<string> {
                        return CommonServices.defaultPost<string>(apiurl + 'api/ShopOffer/Save', item,{}, showSpinner );

                    }
    

                
            getAllAsNameIdentifier(
                showDisabled:boolean,showSpinner = true): Promise<OM.NameIdentifier[]> {
                        return CommonServices.defaultGet<OM.NameIdentifier[]>(apiurl + 'api/ShopOffer/GetAllAsNameIdentifier',{ showDisabled }, showSpinner);

                    }
    

                
            enable(
                identifier:string,
                value:boolean,showSpinner = true): Promise<void> {
                        return CommonServices.defaultGet<void>(apiurl + 'api/ShopOffer/Enable',{ identifier, value }, showSpinner);

                    }
    

                
            getOffersForCliente(
                customerIdentifier:string,
                categoryIdentifier:string,showSpinner = true): Promise<OM.ShopOffer[]> {
                        return CommonServices.defaultGet<OM.ShopOffer[]>(apiurl + 'api/ShopOffer/GetOffersForCliente',{ customerIdentifier, categoryIdentifier }, showSpinner);

                    }
    

                
            duplicaOfferta(
                offertaIdentifier:string,showSpinner = true): Promise<void> {
                        return CommonServices.defaultGet<void>(apiurl + 'api/ShopOffer/DuplicaOfferta',{ offertaIdentifier }, showSpinner);

                    }
    

                
            deleteById(
                offertaIdentifier:string,showSpinner = true): Promise<void> {
                        return CommonServices.defaultGet<void>(apiurl + 'api/ShopOffer/DeleteById',{ offertaIdentifier }, showSpinner);

                    }
    

                
            getAllUpsellOffers(showSpinner = true): Promise<OM.ShopOffer[]> {
                        return CommonServices.defaultGet<OM.ShopOffer[]>(apiurl + 'api/ShopOffer/GetAllUpsellOffers',{  }, showSpinner);

                    }
    

                
            getUpsellOffers(
                parentOfferIdentifier:string,showSpinner = true): Promise<OM.ShopOffer[]> {
                        return CommonServices.defaultGet<OM.ShopOffer[]>(apiurl + 'api/ShopOffer/GetUpsellOffers',{ parentOfferIdentifier }, showSpinner);

                    }
    }

export let ShopOfferClient = new _ShopOfferClient();

class _ShoppingCartClient {

    

                
            getByUser(
                userIdentifier:string,showSpinner = true): Promise<OM.ShoppingCart> {
                        return CommonServices.defaultGet<OM.ShoppingCart>(apiurl + 'api/ShoppingCart/GetByUser',{ userIdentifier }, showSpinner);

                    }
    

                
            save(
                item:OM.ShoppingCart,showSpinner = true): Promise<string> {
                        return CommonServices.defaultPost<string>(apiurl + 'api/ShoppingCart/Save', item,{}, showSpinner );

                    }
    

                
            clear(
                userIdentifier:string,showSpinner = true): Promise<void> {
                        return CommonServices.defaultGet<void>(apiurl + 'api/ShoppingCart/Clear',{ userIdentifier }, showSpinner);

                    }
    }

export let ShoppingCartClient = new _ShoppingCartClient();

class _InterpolationTemplateClient {

    

                
            getAll(showSpinner = true): Promise<OM.InterpolationTemplate[]> {
                        return CommonServices.defaultGet<OM.InterpolationTemplate[]>(apiurl + 'api/InterpolationTemplate/GetAll',{  }, showSpinner);

                    }
    

                
            getByEventName(
                eventName:string,showSpinner = true): Promise<OM.InterpolationTemplate[]> {
                        return CommonServices.defaultGet<OM.InterpolationTemplate[]>(apiurl + 'api/InterpolationTemplate/GetByEventName',{ eventName }, showSpinner);

                    }
    

                
            getById(
                identifier:string,showSpinner = true): Promise<OM.InterpolationTemplate> {
                        return CommonServices.defaultGet<OM.InterpolationTemplate>(apiurl + 'api/InterpolationTemplate/GetById',{ identifier }, showSpinner);

                    }
    

                
            save(
                item:OM.InterpolationTemplate,showSpinner = true): Promise<string> {
                        return CommonServices.defaultPost<string>(apiurl + 'api/InterpolationTemplate/Save', item,{}, showSpinner );

                    }
    

                
            delete(
                identifier:string,showSpinner = true): Promise<void> {
                        return CommonServices.defaultGet<void>(apiurl + 'api/InterpolationTemplate/Delete',{ identifier }, showSpinner);

                    }
    }

export let InterpolationTemplateClient = new _InterpolationTemplateClient();

class _SmsTemplateClient {

    

                
            getAll(showSpinner = true): Promise<OM.SmsTemplate[]> {
                        return CommonServices.defaultGet<OM.SmsTemplate[]>(apiurl + 'api/SmsTemplate/GetAll',{  }, showSpinner);

                    }
    

                
            getByEventName(
                eventName:string,showSpinner = true): Promise<OM.SmsTemplate[]> {
                        return CommonServices.defaultGet<OM.SmsTemplate[]>(apiurl + 'api/SmsTemplate/GetByEventName',{ eventName }, showSpinner);

                    }
    

                
            getById(
                identifier:string,showSpinner = true): Promise<OM.SmsTemplate> {
                        return CommonServices.defaultGet<OM.SmsTemplate>(apiurl + 'api/SmsTemplate/GetById',{ identifier }, showSpinner);

                    }
    

                
            save(
                item:OM.SmsTemplate,showSpinner = true): Promise<string> {
                        return CommonServices.defaultPost<string>(apiurl + 'api/SmsTemplate/Save', item,{}, showSpinner );

                    }
    

                
            delete(
                identifier:string,showSpinner = true): Promise<void> {
                        return CommonServices.defaultGet<void>(apiurl + 'api/SmsTemplate/Delete',{ identifier }, showSpinner);

                    }
    }

export let SmsTemplateClient = new _SmsTemplateClient();

class _BaseUserClient {

    

                
            update(
                item:OM.BaseUser,showSpinner = true): Promise<void> {
                        return CommonServices.defaultPost<void>(apiurl + 'api/BaseUser/Update', item,{}, showSpinner );

                    }
    

                
            getUserType(
                userIdentifier:string,showSpinner = true): Promise<string> {
                        return CommonServices.defaultGet<string>(apiurl + 'api/BaseUser/GetUserType',{ userIdentifier }, showSpinner);

                    }
    

                
            sendAccessData(
                email:string,
                username:string,
                password:string,showSpinner = true): Promise<string> {
                        return CommonServices.defaultGet<string>(apiurl + 'api/BaseUser/SendAccessData',{ email, username, password }, showSpinner);

                    }
    

                
            getListForNetwork(
                roleFilter:string,
                userToExclude:string,showSpinner = true): Promise<OM.NameIdentifierCode[]> {
                        return CommonServices.defaultGet<OM.NameIdentifierCode[]>(apiurl + 'api/BaseUser/GetListForNetwork',{ roleFilter, userToExclude }, showSpinner);

                    }
    

                
            getNewUserCounters(showSpinner = true): Promise<OM.NewUserCountersVm> {
                        return CommonServices.defaultGet<OM.NewUserCountersVm>(apiurl + 'api/BaseUser/GetNewUserCounters',{  }, showSpinner);

                    }
    

                
            assignToNode(
                vm:OM.AssignToVm,showSpinner = true): Promise<void> {
                        return CommonServices.defaultPost<void>(apiurl + 'api/BaseUser/AssignToNode', vm,{}, showSpinner );

                    }
    

                
            savePositionHistoryItem(
                vm:OM.PositionHistoryItemVm,showSpinner = true): Promise<void> {
                        return CommonServices.defaultPost<void>(apiurl + 'api/BaseUser/SavePositionHistoryItem', vm,{}, showSpinner );

                    }
    

                
            saveNotificationsSettings(
                value:OM.NotificationSettings,showSpinner = true): Promise<void> {
                        return CommonServices.defaultPost<void>(apiurl + 'api/BaseUser/SaveNotificationsSettings', value,{}, showSpinner );

                    }
    

                
            saveFcmId(
                vm:OM.AddFcmIdVm,showSpinner = true): Promise<void> {
                        return CommonServices.defaultPost<void>(apiurl + 'api/BaseUser/SaveFcmId', vm,{}, showSpinner );

                    }
    

                
            setPreferredCulture(
                culture:string,showSpinner = true): Promise<void> {
                        return CommonServices.defaultGet<void>(apiurl + 'api/BaseUser/SetPreferredCulture',{ culture }, showSpinner);

                    }
    

                
            setSelectedVillage(
                village:OM.NameIdentifier,
                userIdentifier:string,showSpinner = true): Promise<void> {
                        return CommonServices.defaultGet<void>(apiurl + 'api/BaseUser/SetSelectedVillage',{ village, userIdentifier }, showSpinner);

                    }
    

                
            getShippingAddress(
                userIdentifier:string,showSpinner = true): Promise<OM.Address> {
                        return CommonServices.defaultGet<OM.Address>(apiurl + 'api/BaseUser/GetShippingAddress',{ userIdentifier }, showSpinner);

                    }
    

                
            getNameIdentifier(
                userIdentifier:string,showSpinner = true): Promise<OM.NameIdentifier> {
                        return CommonServices.defaultGet<OM.NameIdentifier>(apiurl + 'api/BaseUser/GetNameIdentifier',{ userIdentifier }, showSpinner);

                    }
    

                
            save(
                item:OM.BaseUser,showSpinner = true): Promise<string> {
                        return CommonServices.defaultPost<string>(apiurl + 'api/BaseUser/Save', item,{}, showSpinner );

                    }
    

                
            completeProfile(
                vm:OM.CompleteProfileVm,showSpinner = true): Promise<void> {
                        return CommonServices.defaultPost<void>(apiurl + 'api/BaseUser/CompleteProfile', vm,{}, showSpinner );

                    }
    

                
            attivaOffertaMultipleFromBackend(
                vm:OM.ActivateOfferOnMultipleCustomersVm,showSpinner = true): Promise<void> {
                        return CommonServices.defaultPost<void>(apiurl + 'api/BaseUser/AttivaOffertaMultipleFromBackend', vm,{}, showSpinner );

                    }
    

                
            removeNota(
                identifier:string,
                userIdentifier:string,showSpinner = true): Promise<void> {
                        return CommonServices.defaultGet<void>(apiurl + 'api/BaseUser/RemoveNota',{ identifier, userIdentifier }, showSpinner);

                    }
    

                
            setPassword(
                userIdentifier:string,
                password:string,showSpinner = true): Promise<string> {
                        return CommonServices.defaultGet<string>(apiurl + 'api/BaseUser/SetPassword',{ userIdentifier, password }, showSpinner);

                    }
    

                
            getAll(
                vm:OM.BaseUserListFilterVm,showSpinner = true): Promise<OM.TablePagedResultOfBaseUserTableVm> {
                        return CommonServices.defaultPost<OM.TablePagedResultOfBaseUserTableVm>(apiurl + 'api/BaseUser/GetAll', vm,{}, showSpinner );

                    }
    

                
            getAllForPush(
                vm:OM.BaseUserFilterForPushVm,showSpinner = true): Promise<OM.TablePagedResultOfBaseUserTableVm> {
                        return CommonServices.defaultPost<OM.TablePagedResultOfBaseUserTableVm>(apiurl + 'api/BaseUser/GetAllForPush', vm,{}, showSpinner );

                    }
    

                
            getAllIdentifiersForPush(
                vm:OM.BaseUserFilterForPushVm,showSpinner = true): Promise<string[]> {
                        return CommonServices.defaultPost<string[]>(apiurl + 'api/BaseUser/GetAllIdentifiersForPush', vm,{}, showSpinner );

                    }
    

                
            getNameIdentifiers(showSpinner = true): Promise<OM.NameIdentifier[]> {
                        return CommonServices.defaultGet<OM.NameIdentifier[]>(apiurl + 'api/BaseUser/GetNameIdentifiers',{  }, showSpinner);

                    }
    

                
            getNameIdentifierByReferralCode(
                referralCode:string,showSpinner = true): Promise<OM.NameIdentifier> {
                        return CommonServices.defaultGet<OM.NameIdentifier>(apiurl + 'api/BaseUser/GetNameIdentifierByReferralCode',{ referralCode }, showSpinner);

                    }
    

                
            searchCliente(
                search:string,
                userIdentifier:string,showSpinner = true): Promise<OM.NameIdentifier[]> {
                        return CommonServices.defaultGet<OM.NameIdentifier[]>(apiurl + 'api/BaseUser/SearchCliente',{ search, userIdentifier }, showSpinner);

                    }
    

                
            getById(
                identifier:string,showSpinner = true): Promise<OM.BaseUser> {
                        return CommonServices.defaultGet<OM.BaseUser>(apiurl + 'api/BaseUser/GetById',{ identifier }, showSpinner);

                    }
    

                
            delete(
                identifier:string,showSpinner = true): Promise<void> {
                        return CommonServices.defaultGet<void>(apiurl + 'api/BaseUser/Delete',{ identifier }, showSpinner);

                    }
    

                
            promoteToOperator(
                identifier:string,showSpinner = true): Promise<string> {
                        return CommonServices.defaultGet<string>(apiurl + 'api/BaseUser/PromoteToOperator',{ identifier }, showSpinner);

                    }
    

                
            getAllOperators(showSpinner = true): Promise<OM.BaseUser[]> {
                        return CommonServices.defaultGet<OM.BaseUser[]>(apiurl + 'api/BaseUser/GetAllOperators',{  }, showSpinner);

                    }
    

                
            exportOperatorExcel(showSpinner = true): Promise<OM.NameIdentifier> {
                        return CommonServices.defaultGet<OM.NameIdentifier>(apiurl + 'api/BaseUser/ExportOperatorExcel',{  }, showSpinner);

                    }
    

                
            getOperatorById(
                identifier:string,showSpinner = true): Promise<OM.Operator> {
                        return CommonServices.defaultGet<OM.Operator>(apiurl + 'api/BaseUser/GetOperatorById',{ identifier }, showSpinner);

                    }
    

                
            getAllOperatorsNameIdentifier(
                showDisabled:boolean,showSpinner = true): Promise<OM.NameIdentifier[]> {
                        return CommonServices.defaultGet<OM.NameIdentifier[]>(apiurl + 'api/BaseUser/GetAllOperatorsNameIdentifier',{ showDisabled }, showSpinner);

                    }
    

                
            addLinkedAccount(
                vm:OM.LoginVm,showSpinner = true): Promise<OM.NameIdentifier> {
                        return CommonServices.defaultPost<OM.NameIdentifier>(apiurl + 'api/BaseUser/AddLinkedAccount', vm,{}, showSpinner );

                    }
    

                
            removeLinkedAccount(
                removeIdentifier:string,showSpinner = true): Promise<void> {
                        return CommonServices.defaultGet<void>(apiurl + 'api/BaseUser/RemoveLinkedAccount',{ removeIdentifier }, showSpinner);

                    }
    

                
            updateContactAddress(
                vm:OM.UpdateAddressVm,showSpinner = true): Promise<void> {
                        return CommonServices.defaultPost<void>(apiurl + 'api/BaseUser/UpdateContactAddress', vm,{}, showSpinner );

                    }
    

                
            getProfonditaNodo(
                fromNode:string,
                toNode:string,showSpinner = true): Promise<number> {
                        return CommonServices.defaultGet<number>(apiurl + 'api/BaseUser/GetProfonditaNodo',{ fromNode, toNode }, showSpinner);

                    }
    

                
            updateFiscalCode(
                leadIdentifier:string,
                newCodFisc:string,showSpinner = true): Promise<void> {
                        return CommonServices.defaultGet<void>(apiurl + 'api/BaseUser/UpdateFiscalCode',{ leadIdentifier, newCodFisc }, showSpinner);

                    }
    

                
            updateLuogoDataNascita(
                vm:OM.UpdateLuogoDataNascitaVm,showSpinner = true): Promise<void> {
                        return CommonServices.defaultPost<void>(apiurl + 'api/BaseUser/UpdateLuogoDataNascita', vm,{}, showSpinner );

                    }
    

                
            updateFiscalAddress(
                vm:OM.UpdateAddressVm,showSpinner = true): Promise<void> {
                        return CommonServices.defaultPost<void>(apiurl + 'api/BaseUser/UpdateFiscalAddress', vm,{}, showSpinner );

                    }
    

                
            updatePersonalData(
                vm:OM.UpdatePersonalDataVm,showSpinner = true): Promise<void> {
                        return CommonServices.defaultPost<void>(apiurl + 'api/BaseUser/UpdatePersonalData', vm,{}, showSpinner );

                    }
    

                
            updateFiscalData(
                vm:OM.UpdateFiscalDataVm,showSpinner = true): Promise<void> {
                        return CommonServices.defaultPost<void>(apiurl + 'api/BaseUser/UpdateFiscalData', vm,{}, showSpinner );

                    }
    

                
            saveContactEmail(
                leadIdentifier:string,
                newEmail:string,showSpinner = true): Promise<void> {
                        return CommonServices.defaultGet<void>(apiurl + 'api/BaseUser/SaveContactEmail',{ leadIdentifier, newEmail }, showSpinner);

                    }
    

                
            getAllNameIdentifiers(showSpinner = true): Promise<OM.NameIdentifier[]> {
                        return CommonServices.defaultGet<OM.NameIdentifier[]>(apiurl + 'api/BaseUser/GetAllNameIdentifiers',{  }, showSpinner);

                    }
    

                
            requestResetPassword(
                userEmail:string,showSpinner = true): Promise<void> {
                        return CommonServices.defaultGet<void>(apiurl + 'api/BaseUser/RequestResetPassword',{ userEmail }, showSpinner);

                    }
    

                
            resetPassword(
                model:OM.ResetPasswordVm,showSpinner = true): Promise<void> {
                        return CommonServices.defaultPost<void>(apiurl + 'api/BaseUser/ResetPassword', model,{}, showSpinner );

                    }
    

                
            confirmEmail(
                userIdentifier:string,
                confirmationCode:string,showSpinner = true): Promise<void> {
                        return CommonServices.defaultGet<void>(apiurl + 'api/BaseUser/ConfirmEmail',{ userIdentifier, confirmationCode }, showSpinner);

                    }
    

                
            getLeadById(
                identifier:string,showSpinner = true): Promise<OM.Lead> {
                        return CommonServices.defaultGet<OM.Lead>(apiurl + 'api/BaseUser/GetLeadById',{ identifier }, showSpinner);

                    }
    

                
            getAllLeads(showSpinner = true): Promise<OM.Lead[]> {
                        return CommonServices.defaultGet<OM.Lead[]>(apiurl + 'api/BaseUser/GetAllLeads',{  }, showSpinner);

                    }
    

                
            getStoricoAssegnazioni(
                leadIdentifier:string,showSpinner = true): Promise<OM.DateValueOfNodeAssignment[]> {
                        return CommonServices.defaultGet<OM.DateValueOfNodeAssignment[]>(apiurl + 'api/BaseUser/GetStoricoAssegnazioni',{ leadIdentifier }, showSpinner);

                    }
    

                
            getAssegnazioni(
                startDate:string,
                endDate:string,
                userIdentifier:string,
                descendants:boolean,showSpinner = true): Promise<OM.LeadAssignmentHistoryVm[]> {
                        return CommonServices.defaultGet<OM.LeadAssignmentHistoryVm[]>(apiurl + 'api/BaseUser/GetAssegnazioni',{ startDate, endDate, userIdentifier, descendants }, showSpinner);

                    }
    

                
            getTelephoneNumber(
                leadIdentifier:string,showSpinner = true): Promise<string> {
                        return CommonServices.defaultGet<string>(apiurl + 'api/BaseUser/GetTelephoneNumber',{ leadIdentifier }, showSpinner);

                    }
    

                
            getScadenze(
                startDate:string,
                endDate:string,
                userIdentifier:string,
                descendants:boolean,
                showLavorati:boolean,showSpinner = true): Promise<OM.ScadenzeLeadVm> {
                        return CommonServices.defaultGet<OM.ScadenzeLeadVm>(apiurl + 'api/BaseUser/GetScadenze',{ startDate, endDate, userIdentifier, descendants, showLavorati }, showSpinner);

                    }
    

                
            assignToList(
                leadIdentifier:string,
                list:string,showSpinner = true): Promise<void> {
                        return CommonServices.defaultGet<void>(apiurl + 'api/BaseUser/AssignToList',{ leadIdentifier, list }, showSpinner);

                    }
    

                
            assignToNoneMultiple(
                leadList:string[],showSpinner = true): Promise<void> {
                        return CommonServices.defaultPost<void>(apiurl + 'api/BaseUser/AssignToNoneMultiple', leadList,{}, showSpinner );

                    }
    

                
            assignMultipleToUser(
                vm:OM.MultipleLeadsActionVm,showSpinner = true): Promise<void> {
                        return CommonServices.defaultPost<void>(apiurl + 'api/BaseUser/AssignMultipleToUser', vm,{}, showSpinner );

                    }
    

                
            assignMultipleToList(
                vm:OM.MultipleLeadsActionVm,showSpinner = true): Promise<void> {
                        return CommonServices.defaultPost<void>(apiurl + 'api/BaseUser/AssignMultipleToList', vm,{}, showSpinner );

                    }
    

                
            changeStatus(
                leadIdentifier:string,
                status:string,showSpinner = true): Promise<void> {
                        return CommonServices.defaultGet<void>(apiurl + 'api/BaseUser/ChangeStatus',{ leadIdentifier, status }, showSpinner);

                    }
    

                
            setToDoDone(
                userIdentifier:string,
                toDoIdentifier:string,showSpinner = true): Promise<void> {
                        return CommonServices.defaultGet<void>(apiurl + 'api/BaseUser/SetToDoDone',{ userIdentifier, toDoIdentifier }, showSpinner);

                    }
    

                
            changeStatusToMultiple(
                vm:OM.MultipleLeadsActionVm,showSpinner = true): Promise<void> {
                        return CommonServices.defaultPost<void>(apiurl + 'api/BaseUser/ChangeStatusToMultiple', vm,{}, showSpinner );

                    }
    

                
            changeSubStatus(
                leadIdentifier:string,
                subStatus:string,showSpinner = true): Promise<void> {
                        return CommonServices.defaultGet<void>(apiurl + 'api/BaseUser/ChangeSubStatus',{ leadIdentifier, subStatus }, showSpinner);

                    }
    

                
            changeSubStatusToMultiple(
                vm:OM.MultipleLeadsActionVm,showSpinner = true): Promise<void> {
                        return CommonServices.defaultPost<void>(apiurl + 'api/BaseUser/ChangeSubStatusToMultiple', vm,{}, showSpinner );

                    }
    

                
            getContactDataOfUser(
                userIdentifier:string,showSpinner = true): Promise<OM.ContactData> {
                        return CommonServices.defaultGet<OM.ContactData>(apiurl + 'api/BaseUser/GetContactDataOfUser',{ userIdentifier }, showSpinner);

                    }
    

                
            checkUsername(
                checkthis:OM.CheckEmailVm,showSpinner = true): Promise<boolean> {
                        return CommonServices.defaultPost<boolean>(apiurl + 'api/BaseUser/CheckUsername', checkthis,{}, showSpinner );

                    }
    

                
            checkNumber(
                checkthis:OM.CheckNumberVm,showSpinner = true): Promise<boolean> {
                        return CommonServices.defaultPost<boolean>(apiurl + 'api/BaseUser/CheckNumber', checkthis,{}, showSpinner );

                    }
    

                
            oblioCliente(
                userIdentifier:string,showSpinner = true): Promise<void> {
                        return CommonServices.defaultGet<void>(apiurl + 'api/BaseUser/OblioCliente',{ userIdentifier }, showSpinner);

                    }
    }

export let BaseUserClient = new _BaseUserClient();

class _LeadClient {

    

                
            getByList(
                vm:OM.LeadListFilterVm,showSpinner = true): Promise<OM.TablePagedResultOfLeadTableVm> {
                        return CommonServices.defaultPost<OM.TablePagedResultOfLeadTableVm>(apiurl + 'api/Lead/GetByList', vm,{}, showSpinner );

                    }
    

                
            exportLeads(
                vm:OM.LeadListFilterVm,showSpinner = true): Promise<OM.NameIdentifier> {
                        return CommonServices.defaultPost<OM.NameIdentifier>(apiurl + 'api/Lead/ExportLeads', vm,{}, showSpinner );

                    }
    

                
            createList(
                listname:string,showSpinner = true): Promise<string> {
                        return CommonServices.defaultGet<string>(apiurl + 'api/Lead/CreateList',{ listname }, showSpinner);

                    }
    

                
            getLists(showSpinner = true): Promise<OM.LeadList[]> {
                        return CommonServices.defaultGet<OM.LeadList[]>(apiurl + 'api/Lead/GetLists',{  }, showSpinner);

                    }
    

                
            removeList(
                listname:string,showSpinner = true): Promise<void> {
                        return CommonServices.defaultGet<void>(apiurl + 'api/Lead/RemoveList',{ listname }, showSpinner);

                    }
    

                
            getByStatusAsColonne(
                userIdentifier:string,
                descendants:boolean,showSpinner = true): Promise<{ [key:string]:OM.LeadTableVm[]; }> {
                        return CommonServices.defaultGet<{ [key:string]:OM.LeadTableVm[]; }>(apiurl + 'api/Lead/GetByStatusAsColonne',{ userIdentifier, descendants }, showSpinner);

                    }
    }

export let LeadClient = new _LeadClient();

class _OperatorClient {

    

                
            getAll(
                vm:OM.BaseUserListFilterVm,showSpinner = true): Promise<OM.TablePagedResultOfBaseUserTableVm> {
                        return CommonServices.defaultPost<OM.TablePagedResultOfBaseUserTableVm>(apiurl + 'api/Operator/GetAll', vm,{}, showSpinner );

                    }
    

                
            getById(
                identifier:string,showSpinner = true): Promise<OM.Operator> {
                        return CommonServices.defaultGet<OM.Operator>(apiurl + 'api/Operator/GetById',{ identifier }, showSpinner);

                    }
    

                
            save(
                item:OM.Operator,showSpinner = true): Promise<string> {
                        return CommonServices.defaultPost<string>(apiurl + 'api/Operator/Save', item,{}, showSpinner );

                    }
    

                
            create(
                vm:OM.CreateUserVm,showSpinner = true): Promise<string> {
                        return CommonServices.defaultPost<string>(apiurl + 'api/Operator/Create', vm,{}, showSpinner );

                    }
    

                
            getListForNetwork(
                roleFilter:string,
                userToExclude:string,showSpinner = true): Promise<OM.NameIdentifier[]> {
                        return CommonServices.defaultGet<OM.NameIdentifier[]>(apiurl + 'api/Operator/GetListForNetwork',{ roleFilter, userToExclude }, showSpinner);

                    }
    }

export let OperatorClient = new _OperatorClient();

interface FileResponse {
    data: Blob;
    status: number;
    fileName?: string;
    headers?: { [name: string]: any };
}

class SwaggerException extends Error {
    message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isSwaggerException = true;

    static isSwaggerException(obj: any): obj is SwaggerException {
        return obj.isSwaggerException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new SwaggerException(message, status, response, headers, null);
}